<template>
	<div :class="modalMode ? 'task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage'">
		<div class="mb-2" v-if="!modalMode">
			<breadCrumbs :routesArray="routesArray"></breadCrumbs>
		</div>
		<div class="items-center justify-between flex">
			<div v-if="!modalMode && presentTemplateTask.mainTaskName" class="title flex items-center">
				<h1 :class="presentTemplateTask.mainTaskName != undefined && presentTemplateTask.mainTaskName.length > 40? 'heading-ellipsis':''">{{ presentTemplateTask.mainTaskName }}</h1>
			</div>
			<div v-if="!modalMode && presentTemplateTask.TaskName" class="title flex items-center">
				<h1 :class="presentTemplateTask.TaskName != undefined && presentTemplateTask.TaskName.length > 40? 'heading-ellipsis':''">{{ presentTemplateTask.TaskName }}</h1>
			</div>
			<div class="flex">
				<div v-if="checkOwner() && presentTemplateTask.statusCode == 10421">
					<!-- v-if="checkOwner() && presentTemplateTask.statusCode == 10402" -->
					<button class="btnprimary mr-1.5" :disabled="clickOnButton" @click="approveOrRejectTheParentApproval(10403)">Approve</button>
					<button class="btnprimary mr-1.5" :disabled="clickOnButton" @click="onClickToRejectByJustificationAtInReview()">Reject</button>
				</div>
				<div v-if="(presentTemplateTask.statusCode == 10401 || (presentTemplateTask.statusCode == 10402 && allSubTaskStatuses())) && !allSubTasksTerminated()">
					<button :class="!isAddDisabled(10301) ? 'btnprimary':'btndisabled pointer-events-none'" v-if="(presentTemplateTask.statusCode == 10401 || (presentTemplateTask.statusCode == 10402 && allSubTaskStatuses())) && !allSubTasksTerminated()" @click="toStartMainTask(7)">Start</button>
				</div>
				
			</div>
		</div>
			
			<div v-if="dotsLoading && pageStatus == 200" class="mt-2">
                <div class="flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white">
                    <dotsloader />
                </div>
            </div>
			<div v-else>
				<div class="w-full minheight">
					<div class="w-full">
						<div class="text-sm">
							<div class="mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey">
								<div class="w-80 heightFixing pr-5">
									<Tabs  v-model:value="selectedTabIndex" scrollable class="heightFixing pr-5">
										<div>
											<TabList >
												<Tab  v-for="(tab, tabIndex) in tabHead" :key="tabIndex" :value="tab.id" @click="toggleTabs(tab)">
													{{ tab.displayName }}
												</Tab>
											</TabList>
										</div>
										<TabPanels class="overflow-auto hide-scrollbar">
											<TabPanel v-for="(tab,tabIndex) in tabHead" :key="tabIndex" :value="tab.id">
												<div class="h-full">
													<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 1">
														<div>
															<div class="border-b border-lightgrey flex justify-between">
																<div class="flex items-center marginTopForDoc marginBottomForDoc justify-center">
																	<div>
																		<p class="my-1 header">Title</p>
																	</div>
																</div>
															</div>
															
															<p class="mt-1.5 text-xs">{{ presentTemplateTask.mainTaskName }}</p>
														</div>
														<div>
															<div class="border-b border-lightgrey">
																<p class="my-1.5 header">Description</p>
															</div>
															<p class="mt-1.5 headerText"></p>
														</div>
														<div class="text-xs">
															{{ presentTemplateTask.description }}
														</div>
														
													</div>
													<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 2">
														<!-- <div> -->
															<div class="border-b border-lightgrey flex justify-between">
																<!-- <div class="flex items-center mt-0.5 marginTopForDoc marginBottomForDoc justify-center"> -->
																	<div>
																		<p class="pb-2.5 mt-2.5 header">Documents</p>
																	</div>
																<!-- </div> -->
																<!-- <div class="mb-1.5"> -->
																	<div class="buttonposition flex justify-center items-center">
																		<!-- :class="TaskDetailsDropDown.taskStatus ==10419 || TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentAuditObject.statusCode == 10403|| presentAuditObject.statusCode == 10418 || presentFindingTaskObj.auditor == userInfo._id? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'" -->
																		<!-- <button for="upload"  class="btnprimary flex justify-center taskEditButtons">Attach</button> -->
																	</div>
																<!-- </div> -->
																
															</div>
															
														<!-- </div> -->
													</div>
													<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 3">
														<div>
														<div class="border-b border-lightgrey flex justify-between">
															<div class="flex items-center justify-center">
																<div>
																	<p class="pb-2.5 mt-2.5 header">Related Tasks</p>
																</div>
															</div>
															<div>														
																<div class="buttonposition flex justify-center items-center sendapprovalheight">
																	<div
																		class="buttonposition flex justify-center items-center"
																	>
																		<button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'filterButtonDisable pointer-events-none' : 'filterButton'">
																			<img  v-if="tableRow.length == 0" src="@/assets/filterIconDisabled.svg" class="filterIcon"/>
																			<img v-else src="@/assets/filterIcon.svg" class="filterIcon"/>
																			Filters
																		</button>
																	</div>										
																</div>
															</div>
														</div>
														</div>
														<div>
															<tableData :tableRowData="tableRow" :headersData="Headers"></tableData>
															<div v-if="toolTipActive">
																<tool-tip :tipText="toolTipText"></tool-tip>
															</div>
														</div>
													</div>
													<div class="overflow-y-scroll descriptionToggle evidence-description" v-if="tab.id == 4">
														<div class="evidence-tab-content">
															<div class="evidence-files-block">
															<div class="border-b border-lightgrey flex justify-between">
																<div class="flex items-center justify-center">
																	<p class="my-1.5 header">Files</p>
																</div>
																<div class="buttonposition flex justify-center items-center sendapprovalheight gap-2">
																	<button
																		@click="openLinkEvidencePopup"
																		:class="isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'"
																	>Link Existing</button>
																	<button
																		@click="openFilePopup('file')"
																		:class="isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'"
																	>Attach</button>
																</div>
															</div>
															<div class="evidence-files-section">
																<div v-if="fileEvidences.length" class="flex mt-4 gap-4 flex-wrap">
																	<div v-for="(doc, idx) in fileEvidences" :key="'file-'+idx">
																		<div class="pdf">
																			<a
																				href="#"
																				@click.prevent="openEvidenceFile(doc)"
																				class="evidence-file-main"
																			>
																			<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='pdf'" />
																			<img src="@/assets/doc.svg" alt="" v-if=" getEvidenceFileExt(doc)=='doc'"/>
																			<img src="@/assets/docx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='docx'" />
																			<img src="@/assets/xls.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xls'" />
																			<img src="@/assets/xlsx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xlsx'" />
																			<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='rtf'"/>
																			<img src="@/assets/txt.svg" alt="" v-if=" getEvidenceFileExt(doc)=='txt'"/>
																			<img src="@/assets/png.svg" alt="" v-if=" getEvidenceFileExt(doc)=='png'"/>
																			<img src="@/assets/jpg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpg'"/>
																			<img src="@/assets/jpeg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpeg'"/>
																			<img src="@/assets/csv.svg" alt="" v-if=" getEvidenceFileExt(doc)=='csv'"/>
																			<img src="@/assets/zip.svg" alt="" v-if=" getEvidenceFileExt(doc)=='zip'"/>
																			<img src="@/assets/mp4.svg" alt="" v-if=" getEvidenceFileExt(doc)=='mp4'"/>
																			<div class="evidence-file-text">
																				<div class="evidence-file-top">
																					<p class="evidence-file-name" :title="doc.filename || doc.name">{{ doc.filename || doc.name || 'N/A' }}</p>
																					<button type="button" class="evidence-file-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentTemplateTask.evidences.indexOf(doc))" :class="isEvidenceAttachDisabled ? 'pointer-events-none' : ''">
																						<img src="@/assets/deleteIcon.svg" alt="Delete" />
																					</button>
																				</div>
																				<div class="evidence-file-meta">
																					<p class="evidence-file-date">{{ doc.evidenceDate ? formatFileAttachedTime(doc.evidenceDate) : 'N/A' }}</p>
																					<p class="evidence-file-task" :title="doc.taskId || 'N/A'">{{ doc.taskId || 'N/A' }}</p>
																				</div>
																			</div>
																			</a>
																		</div>
																	</div>
																</div>
																<p v-else class="text-xs text-placeholdergray mt-3">No files attached</p>
															</div>
															</div>

															<div class="evidence-links-section">
															<div class="border-b border-lightgrey flex justify-between mt-6">
																<div class="flex items-center justify-center">
																	<p class="my-1.5 header">Links</p>
																</div>
																<div class="buttonposition flex justify-center items-center sendapprovalheight gap-2">
																	<button
																		@click="openFilePopup('url')"
																		:class="isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons'"
																	>Add Link</button>
																</div>
															</div>
															<div class="evidence-links-wrap" :class="{ 'evidence-links-wrap--empty': filteredLinkCount === 0 }">
																<div class="evidence-links-scroll">
																	<div class="evidence-links-header">
																		<table class="evidence-links-table" :style="linkTableResizeStyle">
																			<thead>
																				<tr>
																					<th class="cursor-pointer evidence-links-col-title resizable-th" :style="linkColumnStyle('filename')" @click="onLinkHeaderClick('filename')">
																						<div class="flex items-center">
																							<div>Link Title</div>
																							<div class="sort cursor-pointer" :class="linkSortKey === 'filename' ? linkSortClass : 'opacity-50'"></div>
																						</div>
																						<span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'filename')"></span>
																					</th>
																					<th class="cursor-pointer evidence-links-col-link resizable-th" :style="linkColumnStyle('url')" @click="onLinkHeaderClick('url')">
																						<div class="flex items-center">
																							<div>Link</div>
																							<div class="sort cursor-pointer" :class="linkSortKey === 'url' ? linkSortClass : 'opacity-50'"></div>
																						</div>
																						<span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'url')"></span>
																					</th>
																					<th class="cursor-pointer evidence-links-col-date resizable-th" :style="linkColumnStyle('evidenceDate')" @click="onLinkHeaderClick('evidenceDate')">
																						<div class="flex items-center">
																							<div>Evidence Date</div>
																							<div class="sort cursor-pointer" :class="linkSortKey === 'evidenceDate' ? linkSortClass : 'opacity-50'"></div>
																						</div>
																						<span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'evidenceDate')"></span>
																					</th>
																					<th class="evidence-links-col-action"></th>
																				</tr>
																			</thead>
																		</table>
																	</div>
																	<div class="evidence-links-body">
																		<table class="evidence-links-table" :style="linkTableResizeStyle">
																			<tbody v-if="paginatedLinkEvidences.length">
																				<tr
																					v-for="(doc, idx) in paginatedLinkEvidences"
																					:key="'link-'+idx"
																					class="rowHeight evidence-links-row"
																				>
																					<td class="evidence-links-col-title" :style="linkColumnStyle('filename')" :title="doc.filename || doc.name">
																						<div class="table-ellipsis">{{ doc.filename || doc.name || 'N/A' }}</div>
																					</td>
																					<td class="evidence-links-col-link" :style="linkColumnStyle('url')">
																						<div class="table-ellipsis">
																							<a href="#" class="text-primary evidence-link-anchor cursor-pointer" @click.prevent="openEvidenceFile(doc)" :title="doc.url">{{ doc.url }}</a>
																						</div>
																					</td>
																					<td class="evidence-links-col-date" :style="linkColumnStyle('evidenceDate')">{{ doc.evidenceDate ? formatFileAttachedTime(doc.evidenceDate) : 'N/A' }}</td>
																					<td class="evidence-links-col-action">
																						<button type="button" class="evidence-links-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentTemplateTask.evidences.indexOf(doc))" :class="isEvidenceAttachDisabled ? 'pointer-events-none' : ''">
																							<img src="@/assets/deleteIcon.svg" alt="Delete" class="h-5 w-5" />
																						</button>
																					</td>
																				</tr>
																			</tbody>
																				<tbody v-else>
																					<tr>
																						<td class="evidence-links-empty" colspan="4">
																						<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
																					</td>
																				</tr>
																			</tbody>
																		</table>
																	</div>
																</div>
																<pagination
																	v-if="filteredLinkCount > 0"
																	:dynamicPagination="filteredLinkCount"
																	:sortedData="sortedLinkEvidences"
																	@currentPageUpdate="onLinkPaginationUpdate"
																/>
															</div>
															</div>
														</div>
													</div>
													<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 6">
														<div>
															<div class="border-b border-lightgrey flex justify-between">
																<div class="flex items-center justify-center">
																	<div>
																		<p class="my-2.5 header">Comments</p>
																	</div>
																</div>
																<div>
																	<div class="buttonposition flex justify-center items-center sendapprovalheight">
																		<!-- <div class="buttonposition flex justify-center items-center"> -->
																			<button class="btnprimary flex taskEditButtons" v-if="oldComments" @click="sortComments()">
																				<img src="@/assets/sortBy.svg" class="h-3 mr-2" />
																				Newest
																			</button>
																			<button class="btnprimary flex taskEditButtons" v-if="!oldComments" @click="sortComments()">
																				<img src="@/assets/sortBy.svg" class="h-3 mr-2 rotate-180" />
																				Oldest
																			</button>
																		<!-- </div> -->
																	</div>
																</div>
															</div>
															<div>
																<div class="comment-box w-full">
																	<!-- <div class="my-3"><textarea placeholder="Add a Comment" :disabled="presentTemplateTask.statusCode == 10403" class="w-full text-xs border border-lightgrey rounded-sm p-2" rows="4"  v-model="comment" @input="handleInput"></textarea></div>
																	<div class="flex justify-end">
																		<button @click="addComment" class="mr-2" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Add</button>
																		<button @click="clearComment" :class="{ btnprimary: !btnDisabled, btndisabled: btnDisabled }" :disabled="btnDisabled">Cancel</button>
																	</div> -->
																	<div class="my-3">
																		<commentsEditor/>
																	</div>
																	
																</div>
																<div v-if="Object.keys(presentTemplateTask).includes('comments')" class="comments">
																	<div v-for="(obj, index) in presentTemplateTask.comments" class="border border-lightgrey mt-2 rounded-sm flex flex-row p-2" :key="index">
																		<div class="initials">{{extractInitials( (obj.name) )}}</div>
																		<div class="w-1/5">
																			<div class="header">{{ (obj.name) }}</div>
																			<div class="fontSize10PX">{{ obj.createdAt }}</div>
																		</div>
																		<div class="w-4/5 text-xs"><safeHtml :content="obj.comment"/></div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 5">
														<div class="border-b border-lightgrey flex justify-between">
															<div class="flex items-center justify-center">
																<div>
																	<p class="header">Approvals</p>
																</div>
															</div>
															<div>
																<div class="buttonposition flex justify-center items-center sendapprovalheight">
																	<div
																	class="buttonposition flex justify-center items-center"
																	>
																	<button @click="openApprovalpopup()" :class="presentTemplateTask.statusCode==10403 ?'btnprimary pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons mb-1.5'" >Send Approval</button>
																</div>
																</div>
															</div>
														</div>
														<div>
															<div v-for="(approval, number) in presentTemplateTask.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
																<div v-if="approval.createdBy != undefined && !approval.updatedBy" class="initials">{{extractInitials((approval.name))}}</div>
																<div v-if="approval.createdBy != undefined && !approval.updatedBy" class="font-semibold mt-1 text-xs">{{ (approval.name) }}</div>
																
																<div v-if="approval.updatedBy != undefined" class="initials">{{extractInitials((approval.name))}}</div>
																<div v-if="approval.updatedBy != undefined" class="font-semibold mt-1 text-xs">{{ (approval.name) }}</div>

																<div v-if="approval.statusCode == 10401 && approval.action" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
																<div v-else-if="approval.statusCode == 10410 && !approval.action" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
																<div v-else-if="approval.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>

																<div v-if="approval.createdAt != undefined" class="font-semibold mt-1 text-xs">{{formatTime(approval.createdAt)}}</div>
																<div v-if="approval.updatedAt != undefined" class="font-semibold mt-1 text-xs">{{formatTime(approval.updatedAt)}}</div>
															</div>
														</div>
													</div>
													<div class="overflow-y-scroll descriptionToggle" v-if="tab.id == 7">
														<div>
															<div class="border-b border-lightgrey flex justify-between">
																<div class="flex items-center justify-center">
																	<div>
																		<p class="header">History</p>
																	</div>
																</div>
																<div>
																	<div class="buttonposition flex justify-center items-center sendapprovalheight">
																		<div class="buttonposition flex justify-center items-center">
																			<button class="btnprimary flex taskEditButtons" v-if="newHistory" @click="sortWorkLog()">
																				<img src="@/assets/sortBy.svg" class="h-3 mr-2" />
																				Oldest
																			</button>
																			<button class="btnprimary flex taskEditButtons" v-if="!newHistory" @click="sortWorkLog()">
																				<img src="@/assets/sortBy.svg" class="h-3 mr-2 rotate-180" />
																				Newest
																			</button>
																		</div>
																	</div>
																</div>
															</div>
															
														<div v-for="(work, historyIndex) in workLogObject.taskHistory" :key="historyIndex + '-' + (work.updatedAt || work.createdAt || '')" class="bg-white p-4 mb-0.5 border-lightgrey border-b w-full">
																<div class="flex">
																	<div v-if="Object.keys(work).includes('createdBy')" class="initials">
																		{{ extractInitials((work.name)) }}
																	</div>
																	<div v-if="Object.keys(work).includes('updatedBy')" class="initials">
																		{{ extractInitials((work.name)) }}
																	</div>
																	<div class="logContainer w-93">
																		<div class="flex mt-1">
																			<p v-if="Object.keys(work).includes('createdBy')" class="font-semibold text-xs">
																				{{ (work.name) }}
																			</p>
																			<p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold text-xs">
																				{{ (work.name) }}
																			</p>
					
																			<p v-if="work.actionEntity == 10301" class="mx-2 text-xs">{{ 'Created the Task on' }}</p>
																			<p v-else-if="work.statusCode != undefined && work.statusCode == 10418" class="mx-2 text-xs">{{ 'Terminated the Task on' }}</p>
																			<p v-else-if="work.actionEntity == 10302" class="mx-2 text-xs">{{ 'Updated the Task on' }}</p>
					
																			<p v-if="Object.keys(work).includes('createdAt')" class="font-semibold  text-xs">{{ formatTime(work.createdAt) }}</p>
																			<p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold text-xs">{{ formatTime(work.updatedAt) }}</p>
																		</div>
																		<div class="mt-3" v-if="Object.keys(work).includes('additionalInfo')">
																			<div class="flex" v-if="Object.keys(work.additionalInfo).includes('comment')">
																				<p class="font-semibold text-xs">{{ 'Comment :' }}</p>
																				<p class="text-xs w-88"><safeHtml :content="work.additionalInfo.comment"/></p>
																			</div>
																			<div class="flex" v-if="Object.keys(work.additionalInfo).includes('dateId')">
																				<p class="font-normal text-xs">{{'Updated the '}}</p>
																				<p v-if="work.additionalInfo.dateId==20606" class="font-normal text-xs ml-2">{{' Completion Date from'}}</p>
																				<p v-else-if="work.additionalInfo.dateId==20604" class="font-normal text-xs ml-2">{{' Start Date from'}}</p>
																					<p v-else-if="work.additionalInfo.dateId==20605" class="font-normal text-xs ml-2">{{' dueDate from'}}</p>
																				<p v-if="work.additionalInfo.previousCompletionDate!='' && work.additionalInfo.dateId==20606" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousCompletionDate)}}</p>
																				<p v-else-if="work.additionalInfo.previousStartDate!='' && work.additionalInfo.dateId==20604" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousStartDate)}}</p>
																				<p v-else-if="work.additionalInfo.previousEndDate!='' && work.additionalInfo.dateId==20605" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.previousEndDate)}}</p>
																				<p v-else  class="font-semibold text-xs ml-2">N/A</p>
																				<p class="mx-2 font-normal text-xs">{{ 'to' }}</p>
																				
																				<p v-if="work.additionalInfo.updatedCompletionDate!=''&& work.additionalInfo.dateId==20606" class="font-semibold text-xs">{{formatDate(work.additionalInfo.updatedCompletionDate) }}</p>
																				<p v-else-if="work.additionalInfo.updatedStartDate!=''&& work.additionalInfo.dateId==20604" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.updatedStartDate)}}</p>
																				<p v-else-if="work.additionalInfo.updatedEndDate!='' && work.additionalInfo.dateId==20605" class="font-semibold text-xs ml-2">{{formatDate(work.additionalInfo?.updatedEndDate)}}</p>
																				<p v-else class="font-semibold text-xs">N/A</p>
																			</div>
																			<!-- <div class="flex" v-if="Object.keys(work.additionalInfo).includes('approver')">{{ work.additionalInfo }}
																				<p  v-if="Object.keys(work.additionalInfo).includes('action') && work.additionalInfo.action==10301" class="font-semibold text-xs">{{'Requested approval from -'}}</p>
																				<p  v-else-if="!Object.keys(work).includes('action')&& work.additionalInfo.statusCode!=10410" class="font-semibold text-xs">{{'Request approved By -'}}</p>
																				<p class="mx-2 text-xs text-justify" v-if="work.additionalInfo.statusCode!=10410">{{!Object.keys(work.additionalInfo).includes('name')?this.optionsUserArray.find((user:any)=>user.value==work.additionalInfo.approver)?.label|| 'N/A':work.additionalInfo.name }}</p>
																				<div
																				v-if="!Object.keys(work).includes('action') && Object.keys(work).includes('additionalInfo') && work.additionalInfo.statusCode != undefined && work.additionalInfo.statusCode == 10410"
																				class="flex flex-col gap-1"
																			>
																				<div class="flex items-center">
																				<p class="font-semibold text-xs">Request Rejected By -</p>
																				<p class="mx-2 text-xs text-justify">{{ work.additionalInfo.name }}</p>
																				</div>

																				<div
																				v-if="work.additionalInfo.justification != undefined"
																				class="flex items-center gap-2"
																				>
																				<p class="font-semibold text-xs">Justification :</p>
																				<p class="text-xs text-justify">{{ work.additionalInfo.justification }}</p>
																				</div>
																			</div>
																			</div> -->
																			<div
																				v-if="Object.keys(work.additionalInfo).includes('approver')"
																				class="flex flex-col gap-2"
																				>
																				<!-- Requested / Approved (not rejected) -->
																				<template
																					v-if="
																					work.additionalInfo.statusCode == undefined ||
																					work.additionalInfo.statusCode != 10410
																					"
																				>
																					<!-- Row 1: label + approver name -->
																					<div class="flex items-center flex-wrap">
																					<p
																						v-if="
																						Object.keys(work.additionalInfo).includes('action') &&
																						work.additionalInfo.action == 10301
																						"
																						class="font-semibold text-xs"
																					>
																						Requested approval from -
																					</p>
																					<p
																						v-else-if="!Object.keys(work).includes('action')"
																						class="font-semibold text-xs"
																					>
																						Request approved By -
																					</p>
																					<p class="mx-2 text-xs text-justify">
																						{{
																						Object.keys(work.additionalInfo).includes('name')
																							? work.additionalInfo.name
																							: (optionsUserArray.find((user) => user.value == work.additionalInfo.approver)?.label || 'N/A')
																						}}
																					</p>
																					</div>

																					<!-- Row 2: status update (nested additionalInfo) -->
																					<div
																					class="flex items-center flex-wrap"
																					v-if="
																						work.additionalInfo.additionalInfo &&
																						!Array.isArray(work.additionalInfo.additionalInfo) &&
																						work.additionalInfo.additionalInfo.previousStatus != null &&
																						work.additionalInfo.additionalInfo.updatedStatus != null &&
																						work.additionalInfo.additionalInfo.previousStatus !=
																						work.additionalInfo.additionalInfo.updatedStatus
																					"
																					>
																					<p class="font-semibold text-xs">Updated The Status :</p>
																					<div class="flex ml-4">
																						<div
																						class="flex items-center justify-center rounded h-5 labelWidth"
																						:class="colorTemplateBg(work.additionalInfo.additionalInfo.previousStatus)"
																						>
																						<div :class="colorTemplateText(work.additionalInfo.additionalInfo.previousStatus)">
																							{{ getStatusLabel(work.additionalInfo.additionalInfo.previousStatus) }}
																						</div>
																						</div>
																						<div class="mx-4 flex items-center">
																						<img src="@/assets/arrowRight.svg" />
																						</div>
																						<div
																						class="flex items-center justify-center rounded h-5 labelWidth"
																						:class="colorTemplateBg(work.additionalInfo.additionalInfo.updatedStatus)"
																						>
																						<div :class="colorTemplateText(work.additionalInfo.additionalInfo.updatedStatus)">
																							{{ getStatusLabel(work.additionalInfo.additionalInfo.updatedStatus) }}
																						</div>
																						</div>
																					</div>
																					</div>
																				</template>

																				<!-- Rejected -->
																				<div
																					v-else-if="
																					!Object.keys(work).includes('action') &&
																					Object.keys(work).includes('additionalInfo') &&
																					work.additionalInfo.statusCode != undefined &&
																					work.additionalInfo.statusCode == 10410
																					"
																					class="flex flex-col gap-2"
																				>
																					<!-- Row 1: Rejected by + name -->
																					<div class="flex items-center flex-wrap">
																					<p class="font-semibold text-xs">Request Rejected By -</p>
																					<p class="mx-2 text-xs text-justify">
																						{{
																						Object.keys(work.additionalInfo).includes('name')
																							? work.additionalInfo.name
																							: (optionsUserArray.find((user) => user.value == work.additionalInfo.approver)?.label || 'N/A')
																						}}
																					</p>
																					</div>

																					<!-- Row 2: Justification -->
																					<div
																					v-if="work.additionalInfo.justification != undefined"
																					class="flex items-center gap-2 flex-wrap"
																					>
																					<p class="font-semibold text-xs">Justification :</p>
																					<p class="text-xs text-justify">{{ work.additionalInfo.justification }}</p>
																					</div>

																					<!-- Row 3: status update on reject (if backend sends nested status) -->
																					<div
																					class="flex items-center flex-wrap"
																					v-if="
																						work.additionalInfo.additionalInfo &&
																						!Array.isArray(work.additionalInfo.additionalInfo) &&
																						work.additionalInfo.additionalInfo.previousStatus != null &&
																						work.additionalInfo.additionalInfo.updatedStatus != null &&
																						work.additionalInfo.additionalInfo.previousStatus !=
																						work.additionalInfo.additionalInfo.updatedStatus
																					"
																					>
																					<p class="font-semibold text-xs">Updated The Status :</p>
																					<div class="flex ml-4">
																						<div
																						class="flex items-center justify-center rounded h-5 labelWidth"
																						:class="colorTemplateBg(work.additionalInfo.additionalInfo.previousStatus)"
																						>
																						<div :class="colorTemplateText(work.additionalInfo.additionalInfo.previousStatus)">
																							{{ getStatusLabel(work.additionalInfo.additionalInfo.previousStatus) }}
																						</div>
																						</div>
																						<div class="mx-4 flex items-center">
																						<img src="@/assets/arrowRight.svg" />
																						</div>
																						<div
																						class="flex items-center justify-center rounded h-5 labelWidth"
																						:class="colorTemplateBg(work.additionalInfo.additionalInfo.updatedStatus)"
																						>
																						<div :class="colorTemplateText(work.additionalInfo.additionalInfo.updatedStatus)">
																							{{ getStatusLabel(work.additionalInfo.additionalInfo.updatedStatus) }}
																						</div>
																						</div>
																					</div>
																					</div>
																				</div>
																			</div>
																			<div class="flex" v-if="work.additionalInfo.approvalStatusCode == 10410">
																				<p class="font-semibold text-xs text-justify">{{'Approval is Rejected'}}</p>
																			</div>
																			<div class="flex" v-if="work.additionalInfo.approvalStatusCode == 10403">
																				<p class="font-semibold text-xs text-justify">{{'Approval is Accepted'}}</p>
																			</div>
																			<div class="flex" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceTitles') || Object.keys(work.additionalInfo).includes('linkedEvidenceTaskIds')">
																				<p class="font-semibold text-xs">{{ 'Linked the Evidence -' }}</p>
																				<p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceTitles || work.additionalInfo.linkedEvidenceTaskIds }}</p>
																			</div>
																			<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceDates')">
																				<p class="font-semibold text-xs">{{'Evidence Date -'}}</p>
																				<p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceDates || 'N/A' }}</p>
																			</div>
																			<div class="flex" v-if="Object.keys(work.additionalInfo).includes('filename')">
																				<p class="font-semibold text-xs">{{ work.additionalInfo.removed ? 'Deleted the Evidence -' : 'Uploaded the Evidence -' }}</p>
																				<p class="mx-2 text-xs">{{ work.additionalInfo.filename }}</p>
																			</div>
																			<div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('evidenceDate')">
																				<p class="font-semibold text-xs">{{'Evidence Date -'}}</p>
																				<p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.evidenceDate)||'N/A' }}</p>
																			</div>
																			<div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
																				<p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
																				<p class="mx-2 text-xs">{{ (work.additionalInfo.name) }}</p>
																			</div>
																			<div class="flex items-center" v-if="Object.keys(work.additionalInfo).includes('previousStatus') &&(work.additionalInfo.previousStatus!=work.additionalInfo.updatedStatus) ">
																				<div>
																					<p class="font-semibold text-xs">{{'Updated The Status :'}}</p>
																				</div>
																				<div class="flex ml-4">
																					<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.additionalInfo.previousStatus)">
																						<div :class="colorTemplateText(work.additionalInfo.previousStatus)">
																							{{ getStatusLabel(work.additionalInfo.previousStatus) }}
																						</div>
																					</div>
																					<div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
																					<div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorTemplateBg(work.additionalInfo.updatedStatus)">
																						<div :class="colorTemplateText(work.additionalInfo.updatedStatus)">
																							{{ getStatusLabel(work.additionalInfo.updatedStatus) }}
																						</div>
																					</div>
																				</div>
																			</div>
																		</div>
																		<div v-if="Array.isArray(work.additionalInfo)">
																		<div class="flex flex-wrap mt-1" v-for="(info, idx) in work.additionalInfo" :key="idx">
																			<p class="text-xs">
																			Updated the
																			<span class="font-normal">{{ info.key }}</span>
																			<!-- from
																			<span class="font-semibold" v-if="info.key!='assignee'">{{ info.previousData || 'N/A' }}</span>
																			<span class="font-semibold" v-if="info.key=='assignee'">{{ this.optionsUserArray.find((user:any)=>user.value==info.previousData)?.label|| 'N/A' }}</span> -->
																			to
																			<span class="font-semibold" v-if="info.key!='assignee'&& info.key!='startDate'&&info.key!='dueDate'">{{ info.updatedData || 'N/A' }}</span>
																			<span class="font-semibold" v-else-if="info.key=='startDate'|| info.key=='dueDate'">{{ formatFileAttachedTime(info.updatedData) || 'N/A' }}</span>
																			<span class="font-semibold" v-if="info.key=='assignee'">{{ this.optionsUserArray.find((user:any)=>user.value==info.updatedData)?.label|| 'N/A' }}</span>
																			</p>
																		</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</TabPanel>
										</TabPanels>
									</Tabs>
								</div>
								<div class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey">
									<div class="m-3">
										<div class="pb-2 border-b border-lightgrey">
											<h1>Task Details</h1>
										</div>
										<div class="pt-1.5 overflow-y-scroll thirtyWidthToggle">
											<div class="flex flex-col mb-3">
												<label class="controllabel">Task Status</label>
												<div :class="changeBackground()" class="taskstatusboxstyling cursor-pointer" >
													<div :class="changeBackground()" @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)">
														{{ getStatusLabel1(presentTemplateTask.statusCode) }}
													</div>
												</div>
											</div>
				
											
											<div class="mb-3">
												<div>
													<label class="controllabel">Assigned To</label>
													<div>
														<div class="mt-2 mb-3" v-if="presentTemplateTask.statusCode == 10403 || presentTemplateTask.statusCode == 10402 || (presentTemplateTask.createdBy != userInfo._id && presentTemplateTask.assignee != undefined && presentTemplateTask.assignee.value != userInfo._id)">
															{{presentTemplateTask.assignee != undefined ? presentTemplateTask.assignee.label : 'N/A'}}
														</div>
														<div v-else>
															<!-- <multiselect
																v-model="presentTemplateTask.assignee"
																:options="userOptions"
																:showNoOptions="false"
																@search-change="asyncFind"
																:limit-text="limitText"
																:multiple="false"
																:close-on-select="true"
																:disabled="presentTemplateTask.statusCode == 10403"
																:clear-on-select="true"
																label="label"
																open-direction="bottom"
																:hide-selected="true"
																track-by="value"   
																@select="updateAssignedMember(presentTemplateTask.assignee)" 
																:searchable="true"
																:hideArrow="false"
																placeholder="Assigned-To"
																deselectLabel=""
																selectLabel=""
																class="custom-multiselect userSelect"
																:class="{
																	'has-options': userOptions && userOptions.length > 0,
																	'no-options': !userOptions.length &&  searchValue !== ''
																}"
															>
																<template v-slot:noResult>
																	<span>No Members Found</span>
																</template>
															</multiselect> -->
															<AutoComplete 
																v-model="presentTemplateTask.assignee"
																:suggestions="userOptions"
																@complete="asyncFind"
																@item-select="updateAssignedMember(presentTemplateTask.assignee)" 
																:disabled="presentTemplateTask.statusCode == 10403 || isAddDisabled(10301)"
																appendTo="self"
																optionLabel="label"
																optionValue="value"
																placeholder="Assigned-To"
																class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
																:class="{
																	'has-options': userOptions && userOptions.length > 0,
																	'no-options': !userOptions.length &&  searchValue !== ''
																}"
															>
															<template #empty>
																<span>No Members Found</span>
															</template>
															</AutoComplete>
														</div>
													</div>
												</div>
											</div>
											<div class="mb-3">
												<label class="controllabel">Created By</label><br>
												<!-- show process Owner -->
												<div class="my-1">{{ getPersonName(presentTemplateTask.createdBy) }}</div>
											</div>
											<div class="mb-3">
												<!-- <label class="controllabel">Start Date</label><br> -->
												<!-- show Start Date -->
												<!-- <div class="my-1">{{ formatDate(presentTemplateTask.startDate) }}</div> -->
												<div>
													<label class="controllabel">Start Date</label>
													<input
														type="date"
														v-model="presentTemplateTask.startDate"
														class="mt-2 w-full stylingForInputboxstylingForSelectAtPopup"
														@focus="openCalendar"
														:max="presentTemplateTask.dueDate"
														onkeydown="return false"
														placeholder="Select Date"
														:disabled="TaskDetailsDropDown.taskStatus ==10403"
														@change="updateDate(presentTemplateTask.startDate,20604)"
													/>
												</div>
											</div>
											<div class="mb-3">
												<!-- <label class="controllabel">Due Date</label><br>
												show Due Date
												<div class="my-1">{{ formatDate(presentTemplateTask.dueDate) }}</div> -->
												<div>
                                                    <label class="controllabel">Due Date</label>
                                                    <input
                                                        type="date"
                                                        v-model="presentTemplateTask.dueDate"
                                                        class="mt-2 w-full stylingForInputboxstylingForSelectAtPopup"
                                                        @focus="openCalendar"
                                                        onkeydown="return false"
                                                        placeholder="Select Date"
														:disabled="TaskDetailsDropDown.taskStatus ==10403"
                                                        :min="presentTemplateTask.startDate"
                                                        @change="updateDate(presentTemplateTask.dueDate,20605)"
                                                    />
                                                </div>
											</div>
											<div class="mb-3">
											<label class="controllabel mb-2">Completion Date</label><br>
											<!-- show Start Date -->
											<!-- <div class="my-1" v-if="presentTemplateTask.completedAt">{{ formatDate(presentTemplateTask?.completedAt)}}</div>
											<div class="my-1" v-else>N/A</div> -->
											<input
													type="date"
													v-model="presentTemplateTask.completedAt"
													class="mt-2"
													@focus="openCalendar"
													:min="presentTemplateTask.startDate"
													placeholder="Select Date"
													:disabled="TaskDetailsDropDown.taskStatus ==10403"
													@change="updateCompletionDate(presentTemplateTask.completedAt)"
													:class="{'inputboxstylingForSelectAtPopup': presentTemplateTask.startDate === '','stylingForInputboxstylingForSelectAtPopup': presentTemplateTask.startDate !== ''}"
												/>
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Team</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ presentTemplateTask.departmentName?presentTemplateTask.departmentName:'N/A' }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Location</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ presentTemplateTask.locationName?presentTemplateTask.locationName:'N/A' }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Tier</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ getTargetTitle(presentTemplateTask) }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
										<div class="mb-3">
											<label class="controllabel mb-2">Target</label><br>
											<!-- {{ presentSubTask.team }} -->
											<div>{{ getTargetInfo(presentTemplateTask) }}</div>
											<!-- <div v-else class="my-1">N/A</div> -->
										</div>
										
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		<div v-if="showDeleteEvidenceConfirm" class="evidence-delete-confirm">
			<div class="evidence-delete-backdrop" @click="cancelDeleteEvidence"></div>
			<div class="evidence-delete-dialog">
				<div class="evidence-delete-dialog-title">
					<div class="evidence-delete-warning">
						<img src="@/assets/warning.svg" class="evidence-delete-warning-icon" alt="" />
					</div>
					<span>Delete Evidence</span>
				</div>
				<p class="evidence-delete-dialog-message">Are you sure you want to delete this evidence?</p>
				<div class="evidence-delete-dialog-actions">
					<button type="button" class="evidence-delete-cancel" @click="cancelDeleteEvidence">Cancel</button>
					<button type="button" class="evidence-delete-ok" @click="confirmDeleteEvidence">OK</button>
				</div>
			</div>
		</div>
		<popup v-if="importpopUp" :popUp="importpopUp">
			<div class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex">
			<div class="relative w-full max-w-xl">
			<!--content-->
			<div class="border-0 rounded relative flex flex-col w-full bg-white h-screen">
				<!--header-->
				<div class="flex items-center justify-between popupheadingcontainer rounded">
				<h1>{{ evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File' }}</h1>
				<button class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none" @click="onCancelIcon()">
					<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
				</button>
				</div>
				<div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
				<div class="impactcontainer popupbodycontainer flex-1 overflow-y-auto">
				<div class="formcontainer flex flex-col h-full">
					<div class="flex-1 overflow-auto hide-scrollbar">
					<div class="row flex flex-col">
					<div class="upperspacing">
						<label class="controllabel">{{ evidenceAttachMode === 'url' ? 'Title' : 'File Name' }} </label>
						<input v-if="evidenceAttachMode === 'url'" class="inputboxstyling mt-2" type="text" v-model.trim="inputFileName" placeholder="Evidence title"  :class="{'is-invalid': v$.inputFileName.$error }"/>
						<input
							v-else
							class="inputboxstyling mt-2"
							type="text"
							v-model.trim="inputFileName"
							placeholder="Filename"
							@input="v$.inputFileName.$touch()"
							:class="{'is-invalid': v$.inputFileName.$error }"
						/>
						<div v-if="v$.inputFileName.$error " class="text-red-500">
							<div class="error-text" v-if="v$.inputFileName.required.$invalid ">Required</div>
							<div v-else-if="v$.inputFileName.restrictCharacters50 && v$.inputFileName.restrictCharacters50.$invalid" class="error-text">Charcter Limit is exceeded</div>
						</div>
					</div>
				<div class="pt-3" v-if="evidenceAttachMode === 'file'">
					<label class="controllabel">Attachment</label>
					<input
					type="file"
					ref="fileInput"
					class="hidden"
					id="upload"
					@change="handleFileUpload"
					/>
					<div 
					class="w-auto rounded-sm mt-2 p-8
							flex flex-col items-center justify-center text-center transition
							border-2 border-dashed border-lightgrey bg-whitegrey"
					:class="{
						'is-invalid': v$.fileToUpload.$error || pdfValidation,
						'border-primary': isDragOver
					}"
					@dragenter.prevent="onDragOver"
					@dragover.prevent="onDragOver"
					@dragleave.prevent="onDragLeave"
					@drop.prevent="onFileDrop"
					>
					<img
						src="@/assets/fileUploadIcon.svg"
						class="h-10 w-10 mb-3"
						alt="Upload file"
					/>

					<p v-if="fileName === ''" class="text-sm font-semibold text-darkblue mb-4">
						Drag and drop your file here
					</p>
					<p v-else class="text-sm font-semibold text-primary mb-4">
						{{ fileName }}
					</p>
					<div class="flex items-center justify-center gap-2">
						<label for="upload" class="cursor-pointer">
						<span class="browseBtnprimary text-xs gap-1">
							<img src="@/assets/Browse.svg" class="h-4 w-4" alt="" />
							Browse
						</span>
						</label>

						<button
						type="button"
						class="text-xs gap-1"
						:class="fileName === '' ? 'filterButtondisabled pointer-events-none' : 'fileCancelPrimary'"
						:disabled="fileName === ''"
						@click="clearSelectedFile"
						>
						Cancel
						</button>
					</div>
					</div>
					<div class="min-h-[22px] text-red-500">
					<div
						v-if="v$.fileToUpload.$invalid && !pdfValidation && (v$.fileToUpload.$error || pdfValidation)"
						class="error-text text-xs"
					>
						File upload is required
					</div>
					<div
						v-if="pdfValidation && !v$.fileToUpload.$invalid"
						class="text-red-500 text-xs"
					>
						This File Format is not Supported
					</div>
					</div>
					<div class="mt-2 flex flex-col items-center">
						<p class="text-xs text-placeholdergray">
						Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4
						</p>
						<p class="text-xs text-placeholdergray mt-1">
						Maximum File Size: 50 MB
						</p>
					</div>
				</div>
					<div class="pt-3" v-if="evidenceAttachMode === 'url'">
						<label class="controllabel">URL</label>
						<input
							class="inputboxstyling mt-2"
							type="url"
							v-model.trim="evidenceUrl"
							placeholder="URL"
							@input="v$.evidenceUrl.$touch()"
							:class="{'is-invalid': v$.evidenceUrl.$error }"
						/>
						<div v-if="v$.evidenceUrl.$error" class="text-red-500">
							<div class="error-text text-xs" v-if="v$.evidenceUrl.required.$invalid">Required</div>
							<div class="error-text text-xs" v-else-if="v$.evidenceUrl.httpUrl.$invalid">URL must use http or https</div>
						</div>
						<!-- <p class="text-xs text-placeholdergray mt-2">
							Example: https://sharepoint.com/... or https://drive.google.com/...
						</p> -->
					</div>
					<div class="pt-3 w-1/2">
						<label class="controllabel">{{'Evidence Date' }}</label>
						<input
							v-model="evidenceDate"
							type="date"
							class="mt-2 w-full inputboxstylingForSelectAtPopup"
							@focus="openCalendar"
							style="height:28px"
							onkeydown="return false"
							:class="{
								'inputboxstylingForSelectAtPopup': evidenceDate === '',
								'stylingForInputboxstylingForSelectAtPopup': evidenceDate !== '',
								'is-invalid':v$.evidenceDate.$error
								}"
							
							placeholder="Select Date"
							:max="todayDate"

						/>
						<div v-if="v$.evidenceDate.$error" class="text-red-500">
							<div v-if="v$.evidenceDate.$invalid" class="error-text text-xs">{{'Evidence date is required' }}</div>
						</div>
					</div>
					</div>
					</div>
					<div class="border-b border-solid border-lightgrey"></div>
					<div class="buttonposition flex justify-end items-center pt-4">
						<button class="btnprimary" @click="onEvidenceSave" :class="isEvidenceSaveDisabled ? 'btndisabled pointer-events-none ' : 'btnprimary'">Save</button>
					</div>
				</div>
				</div>
			</div>
			</div>
			</div>
		</popup>
		<div v-if="linkEvidencePopup" class="link-existing-confirm">
			<div class="link-existing-backdrop" @click="closeLinkEvidencePopup"></div>
			<div class="link-existing-dialog">
				<div class="link-existing-title">
					<span class="link-existing-warning" aria-hidden="true">
						<img src="@/assets/warning.svg" class="link-existing-warning-icon" alt="" />
					</span>
					<span>Link Existing Evidence</span>
				</div>
				<p class="link-existing-message">Select evidence from the past year listed below.</p>
				<div class="link-existing-tables">
					<div class="link-existing-section-row">
						<div class="link-existing-section">EXISTING EVIDENCE ({{ filteredSortedExistingEvidences.length }})</div>
						<button type="button" class="filterButton flex" @click="toggleExistingEvidenceFilters">
							<img src="@/assets/filterIcon.svg" class="filterIcon" />
							Filters
						</button>
					</div>
					<div class="link-existing-table-wrap" :class="{ 'link-existing-table-wrap--empty': filteredSortedExistingEvidences.length === 0 }">
						<table class="link-existing-table">
							<thead>
								<tr>
									<th class="link-existing-col-check"></th>
									<th class="cursor-pointer" @click="sortExistingEvidence('filename')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TITLE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'filename' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('sourceTaskId')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TASK ID</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'sourceTaskId' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('evidenceType')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">TYPE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceType' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
									<th class="cursor-pointer" @click="sortExistingEvidence('evidenceDate')">
										<div class="flex table-header-label-wrap">
											<div class="table-header-label">EVIDENCE DATE</div>
											<div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceDate' ? existingEvidenceSortClass : 'opacity-50'"></div>
										</div>
									</th>
								</tr>
								<tr v-if="showExistingEvidenceFilters" class="link-existing-filter-row">
									<td class="link-existing-col-check"></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.filename" placeholder="Search" @click.stop /></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.sourceTaskId" placeholder="Search" @click.stop /></td>
									<td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.evidenceType" placeholder="Search" @click.stop /></td>
									<td></td>
								</tr>
							</thead>
							<tbody v-if="filteredSortedExistingEvidences.length">
								<tr v-for="row in filteredSortedExistingEvidences" :key="row.optionKey">
									<td class="link-existing-col-check">
										<input type="checkbox" :checked="isExistingEvidenceSelected(row)" @change="toggleExistingEvidence(row)" />
									</td>
									<td :title="row.filename">{{ row.filename }}</td>
									<td>{{ row.sourceTaskId }}</td>
									<td>{{ getEvidenceTypeLabel(row) }}</td>
									<td>{{ row.evidenceDate ? formatFileAttachedTime(row.evidenceDate) : 'N/A' }}</td>
								</tr>
							</tbody>
							<tbody v-else>
								<tr>
									<td class="link-existing-empty" colspan="5">No Records Found</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="link-existing-actions">
					<button type="button" class="link-existing-cancel" @click="closeLinkEvidencePopup">Cancel</button>
					<button type="button" class="link-existing-save" @click="saveLinkedEvidence" :class="selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : ''">Save</button>
				</div>
			</div>
		</div>
		<popup v-if="showSubTaskPopUp" :popUp="showSubTaskPopUp">
			<template v-slot:header>
				<div class="flex items-center justify-between m-4 rounded">
					<h1>Sub Tasks</h1>
					<button class="float-right text-3xl" @click="onCancelButtonAddPopUp()">
						<img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
					</button>
				</div>
			</template>
				
				<!-- [ "ccid", "title", "team", "startDate", "dueDate", "status", "description", "assignee" ] -->
				<!-- ccid: "668fcf02883b2b4764b9543c"
					dueDate: "2024-08-02"
					startDate: "2024-07-25"
					status: 10411
					team: "IT"
					title: "fghfdxh ftgh rtsy sdfht strystr"
					subTaskDetailsObj -->
					<div class="popup-business flex-1 overflow-y-auto overflow-x-hidden">
                    <div class="flex flex-col h-full">
                        <div class="flex-1 overflow-auto hide-scrollbar">
                            <div class="statuscontainer popupbodycontainer">
                                <div class="formcontainer flex flex-col">
                                    <div class="upperspacing">
                                        <label for="number" class="controllabel">Title</label><br />
                                        <input id="number" class="inputboxstyling mt-2" disabled placeholder="Task Name"  v-model.trim="subTaskDetailsObj.subTasktitle" :class="{'is-invalid': v$.subTaskDetailsObj.subTasktitle.$error }"/>
                                        <div v-if="v$.subTaskDetailsObj.subTasktitle.$error " class="text-red-500">
                                            <div class="error-text" v-if="v$.subTaskDetailsObj.subTasktitle.required.$invalid ">Required</div>
                                        </div>
										<!-- <div class="inputboxstyling mt-2">{{ subTaskDetailsObj.subTasktitle }}</div> -->
                                    </div>
                                    <div class="row flex flex-row upperspacing w-full gap-3">
                                        <div class="w-1/2">
                                            <label class="controllabel text-xs">Start Date</label>
                                            <input
                                                type="date"
                                                class="inputboxstyling mt-2"
                                                @focus="openCalendar"
                                                :min="today"
                                                onkeydown = "return false"
                                                @change="checkForStartDate"
                                                placeholder="Select Start Date"
                                                v-model="subTaskDetailsObj.startDate"
                                                :class="{'is-invalid': v$.subTaskDetailsObj.startDate.$error,'inputboxstylingForSelectAtPopup': subTaskDetailsObj.startDate === '','stylingForInputboxstylingForSelectAtPopup': subTaskDetailsObj.startDate !== ''}"
                                            />
                                            <div v-if="v$.subTaskDetailsObj.startDate.$error " class="text-red-500">
                                                <div class="error-text" v-if="v$.subTaskDetailsObj.startDate.required.$invalid ">Required</div>
                                            </div>
											<!-- <div class="inputboxstyling mt-2">{{ subTaskDetailsObj.startDate }}</div> -->
                                        </div>
                                        <div class="w-1/2">
                                            <label class="controllabel text-xs">Due Date</label>
                                            <input
                                                type="date"
                                                class="inputboxstyling mt-2"
                                                @focus="openCalendar"
                                                onkeydown = "return false"
                                                :min="subTaskDetailsObj.startDate||today"
												:max="presentTemplateTask.dueDate"
                                                @change="checkForStartDate"
                                                placeholder="Select Start Date"
                                                v-model="subTaskDetailsObj.dueDate"
												:class="{'is-invalid': v$.subTaskDetailsObj.dueDate.$error,'inputboxstylingForSelectAtPopup': subTaskDetailsObj.dueDate === '','stylingForInputboxstylingForSelectAtPopup': subTaskDetailsObj.dueDate !== '' }"
                                            />
											
                                            <div v-if="v$.subTaskDetailsObj.dueDate.$error " class="text-red-500">
                                                <div class="error-text" v-if="v$.subTaskDetailsObj.dueDate.required.$invalid ">Required</div>
                                            </div>
											<!-- <div class="inputboxstyling mt-2">{{ subTaskDetailsObj.dueDate }}</div> -->
                                        </div>
                                    </div>
                                    <div class="row flex flex-row w-full gap-3 upperspacing">
                                        <div class="w-1/2">
                                            <label class="controllabel text-xs">Responsibility</label>
											<div class="mt-2">
											<!-- <multiselect
                                                v-model="subTaskDetailsObj.team"
                                                :options="teamOptions"
                                                :showNoOptions="false"
                                                @search-change="asyncFind2"
                                                :limit-text="limitText"
                                                :multiple="false"
                                                :hide-selected="true"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                open-direction="bottom"
                                                label="label"
                                                track-by="value"    
                                                :searchable="true"
                                                :hideArrow="false"
                                                placeholder="Responsibility"
												class="custom-multiselect userSelect"
                                                :class="{
													'is-invalidmultiselect': v$.subTaskDetailsObj.team.$error,
													'has-options': teamOptions && teamOptions.length > 0,
													'no-options': !teamOptions.length &&  searchValue !== ''
												}"
                                            >
                                                <template v-slot:noResult>
                                                    <span>No team Found</span>
                                                </template>
                                            </multiselect> -->
											<AutoComplete 
												v-model="subTaskDetailsObj.team"
												:suggestions="teamOptions"
												disabled
												@complete="asyncFind2"
												optionLabel="label"
												optionValue="value"
												appendTo="self"
												placeholder="Responsibility"
												class="p-inputtext-sm systemsstyling custom-multiselect userSelect"
												:class="{
													'p-invalid': v$.subTaskDetailsObj.team.$error,
													'has-options': teamOptions && teamOptions.length > 0,
													'no-options': !teamOptions.length &&  searchValue !== ''
												}"
											>
												<template #empty>
													<span>No team Found</span>
												</template>
											</AutoComplete>
											</div>
                                            <!-- <input class="inputboxstyling mt-2" placeholder="Responsibility" v-model="subTaskDetailsObj.team" :class="{'is-invalid': v$.subTaskDetailsObj.team.$error }"/> -->
                                            <div v-if="v$.subTaskDetailsObj.team.$error " class="text-red-500">
                                                <div class="error-text" v-if="v$.subTaskDetailsObj.team.required.$invalid ">Required</div>
                                            </div>
											<!-- <div class="inputboxstyling mt-2">{{ subTaskDetailsObj.team }}</div> -->
                                        </div>
                                        <div class="w-1/2">
                                            <label class="controllabel text-xs">Assigned To</label>
											<div class="mt-2">
                                            <!-- <multiselect
                                                v-model="subTaskDetailsObj.assignee"
                                                :options="userOptions"
                                                :showNoOptions="false"
                                                @search-change="asyncFind"
                                                :limit-text="limitText"
                                                :multiple="false"
                                                :hide-selected="true"
                                                :close-on-select="true"
                                                :clear-on-select="true"
                                                open-direction="bottom"
                                                label="label"
                                                track-by="value"    
                                                :searchable="true"
                                                :hideArrow="false"
												class="custom-multiselect userSelect"
                                                placeholder="Assigned to"
                                                :class="{
													'is-invalidmultiselect': v$.subTaskDetailsObj.assignee.$error,
													'has-options': userOptions && userOptions.length > 0,
													'no-options': !userOptions.length &&  searchValue !== ''
												}"
                                            >
                                                <template v-slot:noResult>
                                                    <span>No Members Found</span>
                                                </template>
                                            </multiselect> -->
                                            <AutoComplete 
												v-model="subTaskDetailsObj.assignee"
												:suggestions="userOptions"
												@complete="asyncFind"
												optionLabel="label"
												optionValue="value"
												appendTo="self"
												placeholder="Assigned To"
												class="p-inputtext-sm systemsstyling custom-multiselect userSelect"
												:class="{
													'p-invalid': v$.subTaskDetailsObj.assignee.$error,
													'has-options': userOptions && userOptions.length > 0,
													'no-options': !userOptions.length &&  searchValue !== ''
												}"
											>
												<template #empty>
													<span>No Members Found</span>
												</template>
											</AutoComplete>
											<div v-if="v$.subTaskDetailsObj.assignee.$error " class="text-red-500">
                                                <div class="error-text" v-if="v$.subTaskDetailsObj.assignee.required.$invalid ">Required</div>
                                            </div>
										</div>
                                        </div>
                                    </div>
                                    <div class="upperspacing">
                                        <label class="controllabel text-xs">Description</label><br />
                                        <textarea name="Description" placeholder="Description" id="" class="inputboxstyling mt-2" v-model.trim="subTaskDetailsObj.description"  :class="{'is-invalid': v$.subTaskDetailsObj.description.$error }" disabled></textarea>
                                        <!-- <div v-if="v$.subTaskDetailsObj.description.$error " class="text-red-500">
                                            <div class="error-text" v-if="v$.subTaskDetailsObj.description.required.$invalid ">Required</div>
                                        </div> -->
                                    </div>
									<div class="upperspacing">
                                        <label class="controllabel text-xs">Notes</label><br />
                                        <textarea name="Description" placeholder="Notes" id="" class="inputboxstyling mt-2" v-model.trim="subTaskDetailsObj.notes"></textarea>
                                        <!-- <div v-if="v$.subTaskDetailsObj.description.$error " class="text-red-500">
                                            <div class="error-text" v-if="v$.subTaskDetailsObj.description.required.$invalid ">Required</div>
                                        </div> -->
                                    </div>
                                    
                                </div>
                                
                            </div>
                        </div>
						<div>
						<div class="border-b border-solid border-lightgrey mx-4"></div>
						<div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
							<!-- :class="(JSON.stringify(subTaskDetailsObjDummy) == JSON.stringify(subTaskDetailsObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" -->
							<button class=" mr-2" :disabled="clickOnButton" :class="(JSON.stringify(subTaskDetailsObjDummy) == JSON.stringify(subTaskDetailsObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="onCancelbtn()">Reset</button>
							<button class="" :disabled="clickOnButton" :class="(JSON.stringify(subTaskDetailsObjDummy) == JSON.stringify(subTaskDetailsObj)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="onClickSubmitBtn(subTaskDetailsObj)">Save</button>
						</div>
						</div>
                    </div>
                </div>
		</popup>
		<popup v-if="showApprovalPopup" :popUp="showApprovalPopup">
			<template v-slot:header>
				<div class="flex items-center justify-between popupheadingcontainer rounded">
					<h1>Approval</h1>

					<button class="float-right text-3xl" @click="onCrossbtn()">
						<img src="@/assets/cancel.svg" class="cursor-pointer" />
					</button>
				</div>
			</template>
			
			<div class="popup-business flex-1 overflow-y-auto">
				<div class="flex flex-col h-full ">
					<div class="flex-1 overflow-auto hide-scrollbar">
						<div class="statuscontainer px-5 pb-5">
							<div class="formcontainer flex flex-col">
								<div class="row flex flex-row upperspacing">
									<div class=" w-1/2">
										<label class="controllabel mb-2">Name of the Authority</label>
										<div>
										<!-- <multiselect
											v-model="taskObj.approver"
											:options="authorityOptions"
											:showNoOptions="false"
											@search-change="asyncFind1"
											:limit-text="limitText"
											:multiple="false"
											label="label"
											open-direction="bottom"
											track-by="value"
											:searchable="true"
											:hideArrow="false"
											placeholder="Assigned-To"
											deselectLabel=""
											selectLabel=""
											class="custom-multiselect userSelect"
											:class="{
												'is-invalidmultiselect': v$.taskObj.approver.$error,
												'has-options': userOptions && userOptions.length > 0,
												'no-options': !userOptions.length &&  searchValue !== ''
											 }"
										></multiselect> -->
										<AutoComplete 
											v-model="taskObj.approver"
											:suggestions="authorityOptions"
											@complete="asyncFind1"
											optionLabel="label"
											optionValue="value"
											placeholder="Assigned-To"
											appendTo="self"
											class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
											:class="{
												'p-invalid': v$.taskObj.approver.$error,
												'has-options': userOptions && userOptions.length > 0,
												'no-options': !userOptions.length &&  searchValue !== ''
											}"
										/>
									</div>
									<div v-if="v$.taskObj.approver.$error " class="text-red-500">
										<div class="error-text" v-if="v$.taskObj.approver.$invalid ">Required</div>
									</div>
									</div >
								</div>
								<div class="row flex flex-row upperspacing">
									<div class="w-full">
										<label class="controllabel">Justification or Comments for Approving</label>
										<textarea
											class="inputboxstyling mt-2"
											placeholder="Comments"
											v-model.trim="taskObj.approvalComments"
											:class="{'is-invalid': v$.taskObj.approvalComments.$error }"
										/>
										<div v-if="v$.taskObj.approvalComments.$error " class="text-red-500">
											<div class="error-text" v-if="v$.taskObj.approvalComments.$invalid ">Required</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="border-b border-solid border-lightgrey mx-5"></div>
					<div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
						<button class=" mr-2" :disabled="clickOnButton" :class="(JSON.stringify(taskObj) == JSON.stringify(taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="onCancelbtnAtApproval()">Reset</button>
						<button class="" :disabled="clickOnButton" :class="(JSON.stringify(taskObj) == JSON.stringify(taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary'" @click="clickOnSaveForApproval(taskObj)">Submit</button>
					</div>
				</div>
			</div>
		</popup>
			 <popup v-if="showRejectPopupForMainTask" :popUp="showRejectPopupForMainTask">
				<template v-slot:header>
					<div
					class="flex items-center justify-between popupheadingcontainer rounded"
					>
					<h1>Justification to Reject an Approval</h1>

					<button class="float-right text-3xl" @click="onCrossBtnForFinalApproval()">
						<img src="@/assets/cancel.svg" class="cursor-pointer" />
					</button>
					</div>
				</template>
				<div class='flex flex-col h-full'>
					<div class="flex-1 overflow-auto">
					<div class="popup-business">
						<div>
						<div>
							<div class="statuscontainer px-4 py-4">
							<div class="formcontainer flex flex-col w-full">
									<label class="controllabel"
									>Justification or Comments for Rejecting</label
									>
									<textarea
									class="inputboxstyling mt-2"
									placeholder="Comments"
									v-model.trim="finalJustification.justification"
									@input="v$.finalJustification.justification.$touch()" 
									:class="{ 'is-invalid': v$.finalJustification.justification.$error }"
									/>
									<div v-if="v$.finalJustification.justification.$error" class="text-red-500">
									<div v-if="v$.finalJustification.justification.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
									</div>
							</div>
							</div>
						</div>
						
						</div>
					</div>
					</div>
					<div>
					<div class="border-b border-solid border-lightgrey mx-5"></div>
						<div
							class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
						>
							<button
							class="btnprimary mr-2"
							:class="
								finalJustification.justification == ''
								? 'btndisabled pointer-events-none'
								: 'btnprimary'
							"
							@click="onCancelbtnForFinalApproval()"
							>
							Reset
							</button>
							<button
							:disabled="clickOnButtonForFinal"
							class="btnprimary"
							:class="
								finalJustification.justification == ''
								? 'btndisabled pointer-events-none'
								: 'btnprimary'
							"
							@click="approveOrRejectForActionTasktoComplete(10410, 9)"
							>
							Save
							</button>
						</div>
						</div>
					</div>
    		</popup>
	</div>
</template>
<style scoped>
.evidence-links-col-action {
	width: 8%;
	min-width: 40px;
	text-align: center;
}
.evidence-delete-confirm {
	position: fixed;
	inset: 0;
	z-index: 10060;
	display: flex;
	align-items: center;
	justify-content: center;
}
.evidence-delete-backdrop {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.4);
}
.evidence-delete-dialog {
	position: relative;
	display: block;
	width: 460px;
	max-width: calc(100% - 32px);
	background: #fff;
	border-radius: 6px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
	padding: 20px 24px 16px;
	box-sizing: border-box;
}
.evidence-delete-dialog-title {
	display: flex;
	align-items: center;
	gap: 12px;
	width: 100%;
	margin: 0;
	font-size: 16px;
	font-weight: 700;
	line-height: 22px;
	color: #1a1a1a;
}
.evidence-delete-warning {
	height: 40px;
	width: 40px;
	border-radius: 9999px;
	background: #FFE8D6;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
}
.evidence-delete-warning-icon {
	height: 24px;
	width: 24px;
}
.evidence-delete-dialog-message {
	display: block;
	width: 100%;
	margin: 12px 0 0;
	font-size: 14px;
	line-height: 20px;
	color: #333;
}
.evidence-delete-dialog-actions {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	gap: 8px;
	width: 100%;
	margin-top: 20px;
}
.evidence-delete-cancel,
.evidence-delete-ok {
	height: 32px;
	min-width: 72px;
	padding: 0 16px;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 600;
	line-height: 30px;
	cursor: pointer;
	box-sizing: border-box;
}
.evidence-delete-cancel {
	background: #fff;
	border: 1px solid #d9d9d9;
	color: #333;
}
.evidence-delete-ok {
	background: #1976d2;
	border: 1px solid #1976d2;
	color: #fff;
}
.w-80{
	width: 80%;
}
.heightForDiv{
  height : 29.333px;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.w-20{
	width: 20%;
}
.sendapprovalheight{
	height: 40px;
}
.progressbarB {
	border: 2px solid var(--color-lightgrey);
	background: var(--color-lightgrey);
	position: relative;
	top: -8px;
	z-index: 1;
}
.numberBorder{
    border-top: 1px solid var(--color-lightgrey);
    border-right: 1px solid var(--color-lightgrey);
    border-bottom: 1px solid var(--color-lightgrey);
}
.numberNavy{
    border-left: 2px solid var(--color-primary);
    /* border-width: 2px; */
}
.taskstatusboxstyling{
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: var(--color-lightgrey);
  --tw-bg-opacity: 1;
  /* background-color: rgba(255, 255, 255, var(--tw-bg-opacity)); */
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  --tw-text-opacity: 1;
  /* color: rgba(77, 77, 77, var(--tw-text-opacity)); */
}
.progress {
	background: var(--color-primary);
	position: relative;
	border-radius: 4px;
	z-index: 2;
}
.primaryBackground{
	background-color: var(--color-primary)
}
.descriptionToggle {
	height: 97%;
}
.tabStructure {
	height: calc(100vh - 165px);
}
.thirtyWidthToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}

.thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.thirtyWidthToggle{  
     height:  calc(100vh - 250px);
}
.descriptionToggle::-webkit-scrollbar {
	width: 0 !important;
	height: 0 !important;
	background: transparent;
}
.descriptionToggle::-webkit-scrollbar-thumb {
	background: transparent;
}
.heightFixing {
	height:  calc(100vh - 220px);
	/* height : 64vh; */
}
option {
	background-color: #ffffff;
	color: #000000;
	border-color: pink transparent transparent transparent;
}
.textColorWhite {
	color: white;
}
.approvalbtndisabled {
    height: 1.75rem;
    border-radius: 0.25rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(233 233 233 / var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgb(233 233 233 / var(--tw-bg-opacity));
    padding-left: 10px;
    padding-right: 10px;
    /* font-family: Open Sans; */
    font-size: 0.875rem;
    font-weight: 700;
    line-height: .75rem;
    --tw-text-opacity: 1;
    color: rgb(77 77 77 / var(--tw-text-opacity));
}
.evidenceHeight{
	height: 29px;
}
.custom-select {
    background-image: url("../assets/collapseIcon.svg") !important;
    background-repeat: no-repeat no-repeat;
    background-position: center center;
    background-size: 12px 12px;
    background-position: right 15px center; /* Change the px value here to change the distance */
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
}
.marginBottomForDoc{
	margin-bottom : 1.5px;
}
.marginTopForDoc{
	margin-top : 2.5px;
}
.marginBottomZero{
	margin-bottom : 0px;
}
.pendingEvidence{
    background-color: #8600f040;
}
.evidenceUpload{
    background: rgba(21,39,60,0.24);
}
.labelWidth{
	min-width: 7rem;
}
.framework{
	padding: 12px 170px 12px 12px;
}
.findingCategory{
	padding: 12px 80px 12px 12px;
}
.btnprimary1 {
	cursor: pointer;
	border-bottom-right-radius: 0.25rem;
	border-top-right-radius: 0.25rem;
	--tw-bg-opacity: 1;
	background-color: rgba(21, 42, 67, var(--tw-bg-opacity));
	padding-left: 0.625rem;
	padding-right: 0.625rem;
	padding-top: 0.625rem;
	padding-bottom: 0.625rem;
	/* font-family: Open Sans; */
	font-size: 0.875rem;
	line-height: 1.25rem;
	font-weight: 700;
	line-height: 0.75rem;
	--tw-text-opacity: 1;
	color: rgba(255, 255, 255, var(--tw-text-opacity));
}
:deep(.p-select-dropdown){
  display: none !important;
}
:deep(.p-tab){
  padding: 0px 0px 5px 0px !important;
}
:deep(.p-tabpanels){
  padding-top:5px !important ;
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow{
  background-color: #FF9900 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen{
  background-color: #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen{
  background-color: #00B050 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred{
  background-color: #C00000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error{
  background-color: #FF0000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary{
  background-color: #1976D2 !important;
  font-weight: 600 !important;
}
:deep(.p-select-label){
  color: white !important;
}
:deep(.link-evidence-task-select .p-select-label) {
  color: #000000 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:deep(.link-evidence-task-select .p-select-label.p-placeholder) {
  color: #adadad !important;
}
:deep(.link-evidence-task-select) {
  position: relative;
}
:deep(.link-evidence-task-select .link-evidence-select-overlay) {
  position: absolute !important;
  top: 100% !important;
  left: 0 !important;
  right: auto !important;
  width: 100% !important;
  min-width: 100% !important;
  max-width: 100% !important;
  transform: none !important;
}
:deep(.link-evidence-select-overlay .p-select-option) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
:deep(.link-evidence-task-select.p-multiselect) {
  height: 32px;
  min-height: 32px;
  align-items: center;
}
:deep(.link-evidence-task-select .p-multiselect-label-container) {
  height: 32px;
  padding: 0 0 0 6px !important;
}
:deep(.link-evidence-task-select .p-multiselect-label) {
  color: #000000 !important;
  flex-wrap: nowrap;
  align-items: center;
  height: 32px;
  gap: 4px;
  overflow: hidden;
}
:deep(.link-evidence-task-select .p-multiselect-label .p-chip) {
  height: 22px;
  max-height: 22px;
  max-width: 120px;
  margin: 0;
  padding: 0 6px !important;
  font-size: 12px;
}
:deep(.link-evidence-task-select .p-chip-label) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 22px;
}
:deep(.link-evidence-task-select .p-multiselect-label.p-placeholder) {
  color: #adadad !important;
  display: flex !important;
  align-items: center !important;
  height: 32px !important;
  padding: 0 40px 0 0 !important;
  line-height: 32px !important;
}
:deep(.link-evidence-select-overlay .p-multiselect-option) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
:deep(.p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}

:deep(.p-select-dropdown-icon){
  color: white !important;
}
.task-details-in-modal {
	height: 100%;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	padding: 0 16px 12px;
	margin: 0;
	box-sizing: border-box;
}
.task-details-in-modal > .items-center {
	flex-shrink: 0;
}
.task-details-in-modal > div:not(.items-center) {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.task-details-in-modal .minheight,
.task-details-in-modal .minheight > .w-full,
.task-details-in-modal .minheight > .w-full > .text-sm {
	flex: 1;
	min-height: 0;
	height: 100%;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.task-details-in-modal .tabStructure {
	flex: 1;
	min-height: 0;
	height: auto !important;
	margin-top: 8px;
	overflow: hidden;
}
.task-details-in-modal .heightFixing {
	height: auto !important;
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.task-details-in-modal :deep(.p-tabs) {
	height: 100%;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}
.task-details-in-modal :deep(.p-tabs) > div:first-child {
	flex-shrink: 0;
}
.task-details-in-modal :deep(.p-tabpanels) {
	flex: 1;
	min-height: 0;
	height: auto;
	overflow: hidden !important;
}
.task-details-in-modal :deep(.p-tabpanel),
.task-details-in-modal :deep(.p-tabpanel) > div {
	height: 100%;
	min-height: 0;
	overflow: hidden;
}
.task-details-in-modal .descriptionToggle {
	height: 100% !important;
	max-height: 100%;
	overflow-y: auto !important;
	scrollbar-width: thin;
	scrollbar-gutter: stable;
}
.task-details-in-modal .evidence-description {
	padding-right: 8px;
	box-sizing: border-box;
	overflow-y: auto !important;
	display: flex;
	flex-direction: column;
}
.task-details-in-modal .evidence-description .evidence-tab-content {
	flex: 1;
	min-height: 0;
}
.task-details-in-modal .evidence-description .evidence-links-section {
	flex: 1;
	min-height: 280px;
}
.task-details-in-modal .evidence-description .evidence-links-wrap {
	flex: 1;
	min-height: 240px;
	margin-top: 12px !important;
}
.task-details-in-modal .evidence-description .evidence-links-scroll {
	flex: 1;
	min-height: 180px;
	display: flex;
	flex-direction: column;
	overflow-x: auto;
	overflow-y: hidden;
}
.task-details-in-modal .evidence-description .evidence-links-body {
	flex: 1;
	min-height: 180px; /* show at least 3 rows */
	max-height: 600px;
	overflow-y: auto;
}
.task-details-in-modal .taskDetailsRightBar {
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
.task-details-in-modal .taskDetailsRightBar :deep(.p-select) {
	display: flex;
	flex-direction: row;
	align-items: center;
	height: auto;
	flex: none;
}
.task-details-in-modal .taskDetailsRightBar :deep(.p-select-label) {
	width: auto !important;
	flex: 1 1 auto;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.task-details-in-modal .taskDetailsRightBar > .m-3 {
	flex: 1;
	min-height: 0;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	margin-right: 0;
	padding-right: 0;
}
.task-details-in-modal .thirtyWidthToggle {
	flex: 1;
	min-height: 0;
	height: auto !important;
	overflow-y: auto !important;
	scrollbar-width: thin;
	padding-right: 8px;
	box-sizing: border-box;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar {
	width: 6px !important;
	height: 6px !important;
	background: transparent;
}
.task-details-in-modal .descriptionToggle::-webkit-scrollbar-thumb,
.task-details-in-modal .thirtyWidthToggle::-webkit-scrollbar-thumb {
	background: #c4c4c4 !important;
	border-radius: 4px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import breadCrumbs from '@/components/breadCrumbs.vue';
import { helpers, required, requiredIf } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import popup from '@/components/popup.vue';
import tableData from '@/components/tableData.vue';
import pagination from '@/components/pagination.vue';
import toolTip from '@/components/toolTip.vue'
// import { groupBy } from 'lodash';
import { emitter, toast } from '@/main';
// import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import commentsEditor from '@/components/commentsEditor.vue';
import Multiselect from 'vue-multiselect';
import safeHtml from '@/components/safeHtml.vue';
import dotsloader from '@/components/dotsloader.vue';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import AutoComplete from 'primevue/autocomplete';
import Select from 'primevue/select';
import EvidenceMultiSelect from 'primevue/multiselect';
const restrictCharacters1000 = helpers.regex(/^[\s\S]{0,1000}$/);
const httpUrl = (value: string) => {
	if (!value) return true;
	try {
		const parsed = new URL(value);
		return parsed.protocol === 'http:' || parsed.protocol === 'https:';
	} catch {
		return false;
	}
};
export default defineComponent({
	props: {
		taskId: { type: [String, Number], default: null },
		modalMode: { type: Boolean, default: false },
	},
	emits: ['open-subtask', 'header-info'],
	data(): any {
		return {
			v$: useVuelidate(),
			selectedTabIndex: null,
			fileToUpload: null,
			pageStatus:false,
			statuses:[],
			taskStatuses:[],
			subTaskStatuses:[],
			tabHead: [
				{ displayName: 'Description', id: 1 },

				{ displayName: 'Documents', id: 2 },

				{ displayName: 'Related Tasks', id: 3 },

				{ displayName: 'Evidence', id: 4 },

				{ displayName: 'Approvals', id: 5 },

				{ displayName: 'Comments', id: 6 },

				{ displayName: 'History', id: 7 }
			],
			teamOptions:[],
			placeholder: 'Select a File',
            clickOnButton: false,
			selectedTabObj:{},
			presentTemplateTask:[],
			dummyTemplateTask:{},
			Headers: ['ccid','subTasktitle','team','startDate','dueDate','SubTaskStatus'],
			tableRow:[],
			importpopUp: false,
			showDeleteEvidenceConfirm: false,
			deleteEvidenceIndex: null,
			linkEvidenceTasks: [],
			selectedExistingEvidences: [],
			selectedExistingFiles: [],
			selectedExistingLinks: [],
			linkEvidencePopup: false,
			existingEvidenceSortKey: '',
			existingEvidenceSortDir: 'asc',
			showExistingEvidenceFilters: false,
			existingEvidenceFilters: { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' },
			selectedLinkTask: null,
			inputFileName: '',
			dummyPresentSubTask:[],
			fileName:'',
			evidenceDate:'',
			evidenceAttachMode: 'file',
			evidenceUrl: '',
			linkSortKey: '',
			linkSortDir: 'asc',
			linkCurrentPage: 1,
			linkPageSize: 20,
			linkColumnNames: ['filename', 'url', 'evidenceDate'],
			linkColumnWidths: {},
			linkResizingColumn: null,
			linkResizeStartX: 0,
			linkResizeStartWidth: 0,
			linkDidResize: false,
			authorityOptions:[],
			isInputFileNameValid: true,
			showSubTaskPopUp: false,
			TaskDetailsDropDown: {
				taskStatus: '',
				assignedToDropDown: ''
			},
			taskObj:{
				approver:'',
                approvalComments : ''
            },
			taskObjDummy:{
				approver:'',
                approvalComments : ''
			},
			userOptions:[],
			routesArray:[],
			allSubTasks:[],
			users:[],
			showApprovalPopup: false,
			parentTaskStatus:[
			],
			
			// [ "ccid", "title", "team", "startDate", "dueDate", "status", "description", "assignee" ] 
			subTaskDetailsObj:{
				// ccid:'',
				subTasktitle:'',
				team:'',
				startDate:'',
				dueDate:'',
				description:'',
				assignee:'',
				notes:''
			},
			subTaskDetailsObjDummy:{},
			oldComments: true,
			newHistory: true,
			comment: '',
			comments: [],
			btnDisabled: true,
			selectedOption: '',
			selectedBG: '',
			workLogObject: [],
			optionsUserArray: [],
			orgUsersList: [],
			presentAuditObject: {},
			tasksForAudit: [],
			personObj : '',
			controlsArray : [],
			controlDetailsArray : [],
            controlsArrayAllControls : [],
            controlsDetailsList : [],
			teamObj : '',
			allFrameWorkControls:[],
			locationObject:[],
			fileSelected: false,
			isFileValid: true,
			fileChanged : false,
			findingsForTask:[],
			allActiveControls:[],
			teamObject:[],
			approvingMembers:[],
			toolTipActive:false,
			titleLength: 0,
            titleLengthForTaskName: 0,
            toolTipText:'',
			searchValue:'',
			allProcess:[],
			optionsActivityArray:[],
			allSystems:[],
			optionSystemArray:[],
			showRejectPopupForMainTask : false,
			finalJustification:{
				justification : ''
			}
				// fileObj:{
			// 	inputFileName:'',
			// 	fileToUpload: null,
			// },
		};
	},
	validations() {
		return {
			inputFileName:{
				required,
				restrictCharacters50: function (this: any, value: string) {
					if (this.evidenceAttachMode !== 'file') return true;
					return String(value || '').length <= 50;
				}
			},
			fileToUpload: {
				required: requiredIf(function (this: any) {
					return this.evidenceAttachMode === 'file';
				})
			},
			evidenceUrl: {
				required: requiredIf(function (this: any) {
					return this.evidenceAttachMode === 'url';
				}),
				httpUrl
			},
			evidenceDate:{required},
			subTaskDetailsObj:{
				// ccid:{required},
				subTasktitle:{required},
				team:{required},
				startDate:{required},
				dueDate:{required},
				description:{required},
				assignee:{required},
			},
			taskObj:{
				approver:{required},
				approvalComments:{required},
			},
			authorityOptions:[],
			finalJustification:{
				justification : {restrictCharacters1000}
			},
		};
	},
	components: {
		breadCrumbs,
		popup,
		Multiselect,
		tableData,
		pagination,
		commentsEditor,
		safeHtml,
		dotsloader,
		toolTip,
		Tabs,
		TabList,
		Tab,
		TabPanels,
		TabPanel,
		AutoComplete,
		Select,
		EvidenceMultiSelect
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo',dotsLoading: 'dotsLoading' }),
		currentTaskId(): any {
			return this.taskId || this.$route.params.taskId;
		},
		today() {
			const today = new Date();
			const year = today.getFullYear();
			const month = String(today.getMonth() + 1).padStart(2, '0'); 
			const day = String(today.getDate()).padStart(2, '0');
			return `${year}-${month}-${day}`;
		},
		todayDate() {
			return new Date().toISOString().split('T')[0];
		},
		isEvidenceSaveDisabled(): boolean {
			if (this.evidenceAttachMode === 'url') {
				return this.inputFileName.length === 0 && this.evidenceUrl.length === 0 && this.evidenceDate.length === 0;
			}
			return this.inputFileName.length === 0 && this.evidenceDate.length === 0;
		},
		isEvidenceAttachDisabled(): boolean {
			return this.presentTemplateTask.statusCode == 10403 || this.presentTemplateTask.statusCode == 10401;
		},
		linkTaskOptions(): any[] {
			const currentId = String(this.currentTaskId || '');
			const currentUrls = new Set((this.presentTemplateTask?.evidences || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
			const userId = String(this.userInfo?._id || '');
			const options: any[] = [];
			(this.linkEvidenceTasks || []).forEach((task: any) => {
				if (String(task?._id || '') === currentId || !Array.isArray(task?.evidences)) return;
				const sourceTaskId = task.taskId != null && String(task.taskId) !== '' ? String(task.taskId) : '';
				if (!sourceTaskId) return;
				const hasEvidence = task.evidences.some((doc: any) => {
					if (!doc?.url || currentUrls.has(doc.url)) return false;
					if (String(doc.createdBy || '') !== userId) return false;
					return !!(doc.filename || doc.name);
				});
				if (!hasEvidence) return;
				options.push({ label: sourceTaskId, taskKey: String(task._id), sourceTaskId });
			});
			return options;
		},
		existingEvidenceOptions(): any[] {
			if (!this.selectedLinkTask?.taskKey) return [];
			const currentUrls = new Set((this.presentTemplateTask?.evidences || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
			const userId = String(this.userInfo?._id || '');
			const task = (this.linkEvidenceTasks || []).find((item: any) => String(item?._id || '') === this.selectedLinkTask.taskKey);
			if (!task || !Array.isArray(task.evidences)) return [];
			const options: any[] = [];
			task.evidences.forEach((doc: any) => {
				if (!doc?.url || currentUrls.has(doc.url)) return;
				if (String(doc.createdBy || '') !== userId) return;
				const filename = doc.filename || doc.name;
				if (!filename) return;
				const sourceTaskId = doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== ''
					? String(doc.linkedEvidenceTaskId)
					: (doc.taskId != null && String(doc.taskId) !== '' ? String(doc.taskId) : this.selectedLinkTask.sourceTaskId);
				options.push({
					...doc,
					filename,
					displayName: filename,
					sourceTaskId,
					optionKey: `${sourceTaskId}|${doc.url}`
				});
			});
			return options;
		},
		existingFileEvidenceOptions(): any[] {
			return this.existingEvidenceOptions.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		existingLinkEvidenceOptions(): any[] {
			return this.existingEvidenceOptions.filter((doc: any) => doc?.evidenceType === 'url');
		},
		pastYearExistingEvidences(): any[] {
			const currentId = String(this.currentTaskId || '');
			const currentUrls = new Set((this.presentTemplateTask?.evidences || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
			const userId = String(this.userInfo?._id || '');
			const now = new Date();
			const oneYearAgo = new Date();
			oneYearAgo.setFullYear(now.getFullYear() - 1);
			const rowsByUrl = new Map();
			const originalTaskByUrl = new Map();
			(this.linkEvidenceTasks || []).forEach((task: any) => {
				if (String(task?._id || '') === currentId || !Array.isArray(task?.evidences)) return;
				const plannerTaskId = task.taskId != null && String(task.taskId) !== '' ? String(task.taskId) : '';
				task.evidences.forEach((doc: any) => {
					if (!doc?.url || currentUrls.has(doc.url)) return;
					if (String(doc.createdBy || '') !== userId) return;
					const filename = doc.filename || doc.name;
					if (!filename) return;
					const evidenceTime = Date.parse(doc.evidenceDate);
					if (isNaN(evidenceTime) || evidenceTime < oneYearAgo.getTime() || evidenceTime > now.getTime()) return;
					const linkedTaskId = doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== '' ? String(doc.linkedEvidenceTaskId) : '';
					if (linkedTaskId) {
						originalTaskByUrl.set(doc.url, linkedTaskId);
						return;
					}
					if (doc.taskId != null && String(doc.taskId) !== '' && plannerTaskId && String(doc.taskId) !== plannerTaskId) return;
					const taskMatches = doc.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) === plannerTaskId;
					if (taskMatches && plannerTaskId && !originalTaskByUrl.has(doc.url)) {
						originalTaskByUrl.set(doc.url, plannerTaskId);
					}
					const sourceTaskId = doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== ''
						? String(doc.linkedEvidenceTaskId)
						: (doc.taskId != null && String(doc.taskId) !== '' ? String(doc.taskId) : plannerTaskId);
					if (!sourceTaskId) return;
					const namedOriginal = originalTaskByUrl.get(doc.url);
					if (namedOriginal && plannerTaskId && plannerTaskId !== namedOriginal) return;
					const row = {
						...doc,
						filename,
						sourceTaskId,
						optionKey: `${sourceTaskId}|${doc.url}`
					};
					const existing = rowsByUrl.get(doc.url);
					if (!existing || (taskMatches && !existing.taskMatches) || (namedOriginal && plannerTaskId === namedOriginal && existing.plannerTaskId !== namedOriginal)) {
						rowsByUrl.set(doc.url, { row, taskMatches, plannerTaskId });
					}
				});
			});
			return Array.from(rowsByUrl.values()).filter((entry: any) => {
				const namedOriginal = originalTaskByUrl.get(entry.row.url);
				if (!namedOriginal || !entry.plannerTaskId) return true;
				return entry.plannerTaskId === namedOriginal;
			}).map((entry: any) => entry.row);
		},
		existingEvidenceSortClass(): string {
			return this.existingEvidenceSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
		},
		filteredSortedExistingEvidences(): any[] {
			const filters = this.existingEvidenceFilters || {};
			const rows = (this.pastYearExistingEvidences || []).filter((row: any) => {
				const title = String(row.filename || '').toLowerCase();
				const taskId = String(row.sourceTaskId || '').toLowerCase();
				const typeLabel = String(this.getEvidenceTypeLabel(row)).toLowerCase();
				const dateLabel = row.evidenceDate ? String(this.formatFileAttachedTime(row.evidenceDate)).toLowerCase() : '';
				if (filters.filename && !title.includes(String(filters.filename).toLowerCase())) return false;
				if (filters.sourceTaskId && !taskId.includes(String(filters.sourceTaskId).toLowerCase())) return false;
				if (filters.evidenceType && !typeLabel.includes(String(filters.evidenceType).toLowerCase())) return false;
				if (filters.evidenceDate && !dateLabel.includes(String(filters.evidenceDate).toLowerCase())) return false;
				return true;
			});
			const key = this.existingEvidenceSortKey;
			if (!key) return rows;
			const modifier = this.existingEvidenceSortDir === 'desc' ? -1 : 1;
			return rows.sort((a: any, b: any) => {
				if (key === 'evidenceDate') {
					const aTime = Date.parse(a?.evidenceDate);
					const bTime = Date.parse(b?.evidenceDate);
					if (aTime < bTime) return -1 * modifier;
					if (aTime > bTime) return 1 * modifier;
					return 0;
				}
				if (key === 'sourceTaskId') {
					const aVal = String(a?.sourceTaskId || '');
					const bVal = String(b?.sourceTaskId || '');
					const aNumMatch = aVal.match(/\d+$/);
					const bNumMatch = bVal.match(/\d+$/);
					if (aNumMatch && bNumMatch) {
						const aNum = parseInt(aNumMatch[0], 10);
						const bNum = parseInt(bNumMatch[0], 10);
						if (aNum < bNum) return -1 * modifier;
						if (aNum > bNum) return 1 * modifier;
						return 0;
					}
					if (aVal < bVal) return -1 * modifier;
					if (aVal > bVal) return 1 * modifier;
					return 0;
				}
				const aVal = key === 'evidenceType' ? (a?.evidenceType === 'url' ? 'link' : 'file') : String(a?.filename || '');
				const bVal = key === 'evidenceType' ? (b?.evidenceType === 'url' ? 'link' : 'file') : String(b?.filename || '');
				if (aVal.toLowerCase() < bVal.toLowerCase()) return -1 * modifier;
				if (aVal.toLowerCase() > bVal.toLowerCase()) return 1 * modifier;
				return 0;
			});
		},
		pastYearFileEvidences(): any[] {
			return this.pastYearExistingEvidences.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		pastYearLinkEvidences(): any[] {
			return this.pastYearExistingEvidences.filter((doc: any) => doc?.evidenceType === 'url');
		},
		fileEvidences(): any[] {
			const evidences = this.presentTemplateTask?.evidences;
			if (!Array.isArray(evidences)) return [];
			return evidences.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
		},
		linkEvidences(): any[] {
			const evidences = this.presentTemplateTask?.evidences;
			if (!Array.isArray(evidences)) return [];
			return evidences.filter((doc: any) => doc?.evidenceType === 'url');
		},
		linkSortClass(): string {
			return this.linkSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
		},
		sortedLinkEvidences(): any[] {
			const rows = [...this.linkEvidences];
			const key = this.linkSortKey;
			if (!key) {
				return rows;
			}
			const dir = this.linkSortDir === 'asc' ? 1 : -1;
			return rows.sort((a: any, b: any) => {
				let aVal = '';
				let bVal = '';
				if (key === 'evidenceDate') {
					aVal = a?.evidenceDate || '';
					bVal = b?.evidenceDate || '';
				} else if (key === 'url') {
					aVal = a?.url || '';
					bVal = b?.url || '';
				} else {
					aVal = a?.filename || a?.name || '';
					bVal = b?.filename || b?.name || '';
				}
				return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: 'base' }) * dir;
			});
		},
		filteredLinkCount(): number {
			return this.sortedLinkEvidences.length;
		},
		paginatedLinkEvidences(): any[] {
			const start = (this.linkCurrentPage - 1) * this.linkPageSize;
			const end = this.linkCurrentPage * this.linkPageSize;
			return this.sortedLinkEvidences.slice(start, end);
		},
		linkTableResizeStyle(): any {
			return {
				tableLayout: 'fixed',
				width: '100%',
				maxWidth: '100%',
			};
		},
	},
	methods: {
		limitText (count:any) {
			// return `and ${count} other countries`
			// console.log('countcount',count)
		},
		getEvidenceOwnerName(doc: any): string {
			return this.getPersonName(doc?.createdBy) || 'N/A';
		},
		resetLinkPagination() {
			this.linkCurrentPage = 1;
		},
		onLinkPaginationUpdate(currentPage: any, pageSize: any) {
			this.linkCurrentPage = currentPage;
			this.linkPageSize = pageSize;
		},
		linkColumnStyle(column: string) {
			const width = this.linkColumnWidths[column];
			if (!width) {
				return {};
			}
			return {
				width: width + 'px',
				minWidth: '60px',
				maxWidth: width + 'px',
			};
		},
		snapshotLinkColumnWidths() {
			const headers = this.$el?.querySelectorAll?.('.evidence-links-header thead th') || [];
			const names = this.linkColumnNames || [];
			headers.forEach((th: HTMLElement, index: number) => {
				const column = names[index];
				if (column && this.linkColumnWidths[column] == null) {
					this.linkColumnWidths[column] = Math.round(th.getBoundingClientRect().width);
				}
			});
		},
		getLinkContainerWidth() {
			const container = this.$el?.querySelector?.('.evidence-links-scroll') as HTMLElement | null;
			if (container) {
				return Math.max(60, Math.floor(container.clientWidth || container.getBoundingClientRect().width));
			}
			return window.innerWidth;
		},
		maxWidthForLinkColumn(column: string, proposedWidth: number) {
			const names = this.linkColumnNames || [];
			const otherWidth = names.reduce((sum: number, name: string) => {
				if (name === column) {
					return sum;
				}
				return sum + (Number(this.linkColumnWidths[name]) || 60);
			}, 0);
			const containerWidth = this.getLinkContainerWidth();
			const maxTotal = Math.max(60, containerWidth - otherWidth);
			return Math.min(proposedWidth, maxTotal, containerWidth);
		},
		clampLinkWidthsToContainer() {
			const names = this.linkColumnNames || [];
			if (!names.length || !Object.keys(this.linkColumnWidths || {}).length) {
				return;
			}
			const containerWidth = this.getLinkContainerWidth();
			const total = names.reduce((sum: number, name: string) => sum + (Number(this.linkColumnWidths[name]) || 0), 0);
			if (total <= containerWidth) {
				return;
			}
			const scale = containerWidth / total;
			const next: Record<string, number> = { ...this.linkColumnWidths };
			names.forEach((name: string) => {
				if (next[name]) {
					next[name] = Math.max(60, Math.round(next[name] * scale));
				}
			});
			let scaledTotal = names.reduce((sum: number, name: string) => sum + (Number(next[name]) || 0), 0);
			let overflow = scaledTotal - containerWidth;
			for (let i = names.length - 1; i >= 0 && overflow > 0; i--) {
				const name = names[i];
				const current = Number(next[name]) || 0;
				if (current > 60) {
					const reduced = Math.max(60, current - overflow);
					overflow -= current - reduced;
					next[name] = reduced;
				}
			}
			this.linkColumnWidths = next;
		},
		startLinkColumnResize(event: MouseEvent, column: string) {
			this.snapshotLinkColumnWidths();
			this.clampLinkWidthsToContainer();
			const th = (event.currentTarget as HTMLElement)?.closest('th');
			this.linkResizingColumn = column;
			this.linkResizeStartX = event.clientX;
			this.linkResizeStartWidth = this.linkColumnWidths[column] || th?.getBoundingClientRect().width || 60;
			this.linkDidResize = false;
			document.body.classList.add('col-resizing');
			document.addEventListener('mousemove', this.onLinkColumnResize);
			document.addEventListener('mouseup', this.stopLinkColumnResize);
		},
		onLinkColumnResize(event: MouseEvent) {
			if (!this.linkResizingColumn) {
				return;
			}
			const delta = event.clientX - this.linkResizeStartX;
			if (Math.abs(delta) > 2) {
				this.linkDidResize = true;
			}
			const nextWidth = this.maxWidthForLinkColumn(
				this.linkResizingColumn,
				Math.max(60, Math.round(this.linkResizeStartWidth + delta))
			);
			this.linkColumnWidths = { ...this.linkColumnWidths, [this.linkResizingColumn]: nextWidth };
		},
		stopLinkColumnResize() {
			this.linkResizingColumn = null;
			document.body.classList.remove('col-resizing');
			document.removeEventListener('mousemove', this.onLinkColumnResize);
			document.removeEventListener('mouseup', this.stopLinkColumnResize);
		},
		onLinkHeaderClick(column: string) {
			if (this.linkDidResize) {
				this.linkDidResize = false;
				return;
			}
			this.sortLinkEvidences(column);
		},
		sortLinkEvidences(key: string) {
			if (this.linkSortKey === key) {
				this.linkSortDir = this.linkSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				this.linkSortKey = key;
				this.linkSortDir = 'asc';
			}
			this.resetLinkPagination();
		},
		getEvidenceFileExt(doc: any) {
			if (!doc?.url || doc.evidenceType === 'url') return '';
			try {
				const path = new URL(doc.url).pathname;
				return (path.split('.').pop() || '').toLowerCase();
			} catch {
				return (String(doc.url).split('.').pop() || '').toLowerCase();
			}
		},
		getEvidenceTypeLabel(doc: any) {
			if (doc?.evidenceType === 'url') return String(doc.evidenceType).toUpperCase();
			const ext = this.getEvidenceFileExt(doc);
			return ext ? ext.toUpperCase() : 'File';
		},
		onCrossBtnForFinalApproval(){
			this.showRejectPopupForMainTask = false;
			this.finalJustification.justification = '';
		},
		onClickToRejectByJustificationAtInReview(){
		this.finalJustification.justification = '';
		this.showRejectPopupForMainTask = true;
		},
		onCancelbtnForFinalApproval(){
			// this.onCrossBtnForFinalApproval();
			this.finalJustification.justification = '';
		},
		async approveOrRejectForActionTasktoComplete(statusCode: any, typeId: any) {
			this.clickOnButton = true;			
			let subtaskId: any = this.currentTaskId
			const payload: any={
				statusCode: statusCode,
				updatedBy: this.userInfo._id,
				justification:this.finalJustification.justification
			}
			// /api/org/task/:taskId/update/approval

			// POST

			// => payload for approving approval

			// {statusCode: 10403 , updatedBy:'',updatedAt:''}
			console.log('pppp',payload);
			
			// await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${taskId}/update/approval`,payload
			await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${subtaskId}/update/approval`,payload).then((res: any) => {
                
				// console.log("this.presentSubTask",this.presentSubTask)
            });
			if(statusCode == 10403){
                toast.success(`Approval Approved`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				// await this.getSubTaskHistoryObject()
            }else if(statusCode == 10410){
				this.showRejectPopupForMainTask = false;
                toast.error(`Approval Rejected`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				this.clickOnButton = false;
				await this.getParentTaskHistoryObject() ;
				await this.getPresentTemplateTask();
				// await this.getSubTaskHistoryObject() 
            }
			// await this.getPresentSubTask();
		},
		allSubTaskStatuses(){
			if(this.tableRow.length>0){
				let allsubTaskStatus = this.tableRow.every((task:any)=>task.SubTaskStatus!=10411);
				if(allsubTaskStatus==false){					
					return true
				}
				else{					
					return false;
				}
				
			}

		},
		allSubTasksTerminated(){
			if(this.tableRow.length>0){
				return this.tableRow.every((task:any)=>task.SubTaskStatus==10418 || task.SubTaskStatus==10403);
			}
			return false;
		},
		getTargetTitle(data:any){
			if (data.activityId) {
				let Title = 'Activity';
				return Title
			} else if (data.systemId) {
				let Title = 'System';
				return Title
			}else if (data.projectId) {
				let Title = 'Project';
				return Title
			}else {
				return 'N/A'
			}
		},
		formatFileAttachedTime(time: any) {    
			let now = moment(time);
			return now.format("DD-MM-YYYY");
		},
		async updateCompletionDate(obj:any) {
			let payload:any= {completedAt: obj };
			await this.updateTemplateTask(8,payload);
		},
		async updateDate(updatedDate:any,type:any){
				let now = new Date();
				let selectedDate = new Date(updatedDate);
				selectedDate.setHours(
					now.getHours(),
					now.getMinutes(),
					now.getSeconds(),
					now.getMilliseconds()
				);
	
				if(type==20604){
					let payload: any = { startDate: selectedDate};
					await this.updateTemplateTask(8,payload,type)
				}
				if(type==20605){
					let payload: any = { endDate: selectedDate};
					await this.updateTemplateTask(8,payload,type)
				}
			},
		formatDate(date:any) {
			if(date==undefined){
				return 'N/A'
			}
			let now = moment(date);
			return now.format('DD-MM-YYYY');
		},
		changeDateFormat(date: any) {
            if(date != undefined){
                return date.split('-').reverse().join('-');
            }
		},
		isAddDisabled(permission:any) {
            try {
				if (!this.userInfo || !this.userInfo.organisationType) {
					return true;  // Disable the button if userInfo is not available
				}
				
                if (this.userInfo.organisationType !== 10701) {
                    return false; // or true if you want to disable for others
                }
                return !this.hasPermission(this.userInfo, 10007, 10117, permission);
            } catch (e) {
                console.error("Permission check failed:", e);
                return true; // safest fallback = disable the button
            }
	    },
        hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
		if (!userInfo || !userInfo.apps) return false;

		const app = userInfo.apps.find((a:any) => a.appId === appId);
		if (!app) return false;

		const entity = app.entities?.find((e:any) => e.entityId === entityId);
		if (!entity) return false;

		return entity.permissions?.includes(permissionId) || false;
	    },
		getTargetInfo(data:any){
			if(data.activityId){
				let activity = this.optionsActivityArray.find((activity:any)=>data.activityId.toString()== activity.value.toString());
				return activity!=undefined?activity.label:'N/A'
			}
			else if(data.systemId) {
				let System = this.optionSystemArray.find((sys:any)=>data.systemId.toString()== sys.value.toString());
				return System!=undefined?System.label:'N/A'			
			}
			else{
				return 'N/A'
			}
		},
		getUserteamName(data:any){
			let users =this.orgUsersList.find((u:any)=>u._id.toString() == data?.value);
			if(users!=undefined){
				if(users.departmentId!=undefined){
					let d = this.users.find((dept:any)=>dept._id.toString()==users.departmentId);					
					 return d?d.displayName:'N/A'
				}
				else{
					return 'N/A'
				}
				// return users.departmentId
			}
			else{
				return 'N/A'
			}
			
		},
		openCalendar(event: any) {
            event.target.showPicker();
        },
		checkForStartDate(){
			if(this.subTaskDetailsObj.dueDate != ''){
				if(this.subTaskDetailsObj.startDate > this.subTaskDetailsObj.dueDate){
					this.subTaskDetailsObj.dueDate = ''
				}
			}
		},
		getStatusLabel1(statusCode: any){
			if(this.statuses.taskStatus!=undefined && statusCode!=undefined){
				let result: any = this.statuses.taskStatus.find((data: any)=>{
				return data.id == statusCode
			})
			if(result != undefined){
				return result.label
			} else{
				return 'N/A'
			}
			}
			
		},
		asyncFind2(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.teamOptions = []
			}else if(query.length > 0){
				this.teamOptions = this.teamObject.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
		asyncFind(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.userOptions = []
			}else if(query.length > 0){
				this.userOptions = this.optionsUserArray.filter((obj:any)=>{return (obj.label.toLowerCase().includes(query.toLowerCase())&&this.dummyPresentSubTask?.assignee?.value!=obj.value)})
			}
		},
		asyncFind1(query:any){
			query=query.query
			this.searchValue = query;
			if(query == ''){
				this.authorityOptions = []
			}else if(query.length > 0){
				this.authorityOptions = this.approvingMembers.filter((obj:any)=>{return obj.label.toLowerCase().includes(query.toLowerCase())})
			}
		},
		changeFrameWorkControlNums(){
			this.selectedControlNumbers = []
			this.findingsObject.frameWorkControl = ''

			if(this.findingsObject.frameworks == 'Internal Controls'){
				this.selectedControlNumbers.push(this.presentTemplateTask.controlNumber);
				this.findingsObject.frameWorkControl = this.presentTemplateTask.controlNumber
			}else{
				let obj:any = this.presentTemplateTask.frameworks.find((obj:any)=>{return obj.framework == this.findingsObject.frameworks});
				obj.controlsDetailsArray.map((ctrlObj:any)=>{this.selectedControlNumbers.push(ctrlObj.controlNumber);})
			}
		},
		toStartMainTask(type: any){
			let payload : any ={createdBy: this.userInfo._id,updatedAt:new Date()}
			this.updateTemplateTask(type,payload)
			// this.$router.push({ name: 'tasks'});
			// this.$router.push({ name: 'tasks'});
		},
		async getParentTaskHistoryObject() {
			// /api/org/task/:taskId/history/get
			
			// for task history
			await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.currentTaskId}/history/get`).then((result: any) => {
				const mainObject = result.data;
				this.workLogObject = mainObject;
			});
		},
		// onClickSubmitBtn(obj:any){
		// 	this.v$.$touch();
		// 	if(!this.v$.subTaskDetailsObj.$invalid){
		// 		this.onClickUpdateBtn(obj)
		// 		this.showSubTaskPopUp = false
		// 	}
			
		// },
		applySelectedFile(file:any) {
			this.fileName = file.name;
			this.fileToUpload = file;

			const fileNameParts = file.name.split('.');
			fileNameParts.pop();
			const nameWithoutExtension = fileNameParts.join('.');
			if (this.inputFileName.trim() === '') {
				this.inputFileName = nameWithoutExtension;
				if (nameWithoutExtension.length > 50) {
					this.v$.inputFileName.$touch();
				}
			}

			// const fileExtension = file.name.split('.').pop();
			const fileExtension = file.name.split('.').pop()?.toLowerCase();
			if (
				fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' ||
				fileExtension == 'xlsx' || fileExtension == 'jpeg' || fileExtension == 'png' ||
				fileExtension == 'jpg' || fileExtension == 'mp4' || fileExtension == 'doc' ||
				fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' ||
				fileExtension == 'zip' || fileExtension == 'ods'
			) {
				this.pdfValidation = false;
				this.v$.$reset();
			} else {
				this.pdfValidation = true;
			}
		},

		handleFileUpload(event:any) {
			const file = event?.target?.files?.[0];
			if (file) {
				this.applySelectedFile(file);
			} else {
				this.fileName = '';
				this.inputFileName = '';
			}
		},
		onDragOver() {
			this.isDragOver = true;
		},
		onDragLeave() {
			this.isDragOver = false;
		},
		onFileDrop(event:any) {
			this.isDragOver = false;
			const file = event.dataTransfer?.files?.[0];
			if (file) {
				this.applySelectedFile(file);
			}
		},
		clearSelectedFile() {
			this.fileName='';
			this.fileToUpload = '';
			this.pdfValidation = false;
			this.v$.$reset();

			if (this.$refs.fileInput) {
				this.$refs.fileInput.value = '';
			}
		},
		async onClickSubmitBtn(obj: any){
			this.v$.$touch();
			// /api/org/subTask/:taskId/update
 
			// POST
			
			// { Updated key value pairs}
			// subTaskDetailsObj:{
			// 	ccid:'',
			// 	title:'',
			// 	team:'',
			// 	startDate:'',
			// 	dueDate:'',
			// 	status:'',
			// 	description:'',
			// 	assignee:'',
			// 	notes:''
			// },
			if(!this.v$.subTaskDetailsObj.$invalid){
				this.clickOnButton = true;
				
			let taskId:any = obj._id
			const copyOfgobj: any={
				title:obj.subTasktitle,
				team:obj.team.value,
				startDate:obj.startDate,
				dueDate:obj.dueDate,
				description:obj.description,
				assignee:obj.assignee.value,
				notes:obj.notes,
				updatedBy:this.userInfo._id
			}
			 // Normalize dummy to same keys/shape as payload
			const previousNormalized: any = {
			title: this.subTaskDetailsObjDummy.subTasktitle,
			team: this.subTaskDetailsObjDummy.team?.value,
			startDate: this.subTaskDetailsObjDummy.startDate,
			dueDate: this.subTaskDetailsObjDummy.dueDate,
			description: this.subTaskDetailsObjDummy.description,
			assignee: this.subTaskDetailsObjDummy.assignee?.value,
			notes: this.subTaskDetailsObjDummy.notes,
			};
		const keysToCompare = [
		'title',
		'team',
		'startDate',
		'dueDate',
		'description',
		'assignee',
		'notes',
		];
		const additionalInfo: any[] = [];
		keysToCompare.forEach((key) => {
		const previousData = previousNormalized[key] ?? '';
		const updatedData = copyOfgobj[key] ?? '';
		if (String(previousData) !== String(updatedData)) {
			additionalInfo.push({
			key,              // optional but useful for history UI
			previousData,
			updatedData,
			});
		}
		});
		const payload: any = {
		...copyOfgobj,
		additionalInfo, // array of changed fields
		};		
			// const payload: any ={...copyOfgobj}
			try {
				await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/subTask/${taskId}/update`, payload).then(async (result: any) => {
					toast.info(`Updated`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				});
				this.showSubTaskPopUp = false
				this.v$.$reset();
			} catch {
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			} finally {
                this.clickOnButton = false;
            }
		}
			await this.getAllSubTasksForTemplate();
			// await this.updateTemplateTask(5,payload)
			
		},
		getLocation(teamId:any){
                
			let presentteamObject:any = this.users.find((obj: any) => {
				return obj._id == teamId;
			});

			if (presentteamObject!=undefined && presentteamObject.type == 20301){
				return 'Global';
			}else{
				if(this.presentTemplateTask.location == undefined || this.presentTemplateTask.location == null ){
					return 'N/A'
				}else{
					return this.getLocationName(this.presentTemplateTask.location[0].entity)
				}
			}
		},
		getLocationName(locationId: any) {
            let locationObj = this.locationObject.find((obj: any) => {
                return obj.value == locationId;
            });
            if (locationObj == undefined) {
                let empty = '';
                return empty;
            } else {
                return locationObj.label;
            }
        },
		sanitizeUrl(rawUrl: any) {
			if (typeof rawUrl !== 'string') {
				return '#';
			}
			const trimmed = rawUrl.trim();
			const lower = trimmed.toLowerCase();
			// Block dangerous schemes
			if (lower.startsWith('javascript:') || lower.startsWith('data:') || lower.startsWith('vbscript:')) {
				return '#';
			}
			// Allow http(s) and common relative URLs
			if (/^(https?:\/\/|\/|\.{1,2}\/)/.test(trimmed)) {
				return trimmed;
			}
			return '#';
		},
		getS3KeyFromUrl(fileUrl: string) {
			// https://crystalnikhil.s3.amazonaws.com/planner/uuid.pdf
			// → planner/uuid.pdf
			try {
				const url = new URL(fileUrl);
				return url.pathname.startsWith('/')
				? url.pathname.slice(1)
				: url.pathname;
			} catch (e) {
				return '';
			}
			},

		async openEvidenceFile(doc: any) {
			const fileUrl = typeof doc === 'string' ? doc : doc?.url;
			if (!fileUrl) return;

			if (typeof doc !== 'string' && doc?.evidenceType === 'url') {
				window.open(fileUrl, '_blank', 'noopener,noreferrer');
				return;
			}

			const key = this.getS3KeyFromUrl(fileUrl);
			if (!key) {
				return;
			}

			try {
				const response = await this.$http.post(
				`${process.env.VUE_APP_FILE_API}/presignedurl/v3`,
				{ key } // bucket comes from AWS_BUCKET_NAME on server
				);

				const signedUrl =
				typeof response.data === 'string'
					? response.data
					: response.data?.url;

				if (signedUrl) {
				window.open(signedUrl,'_Self', 'noopener,noreferrer');
				}
			} catch (err) {
				console.error(err);
				// optional: toast.error('Unable to open file');
			}
			},
		openDeleteEvidenceConfirm(evidenceIndex: number) {
			this.deleteEvidenceIndex = evidenceIndex;
			this.showDeleteEvidenceConfirm = true;
		},
		cancelDeleteEvidence() {
			this.showDeleteEvidenceConfirm = false;
			this.deleteEvidenceIndex = null;
		},
		async confirmDeleteEvidence() {
			const evidenceIndex = this.deleteEvidenceIndex;
			this.showDeleteEvidenceConfirm = false;
			this.deleteEvidenceIndex = null;
			if (evidenceIndex == null) return;
			await this.removeEvidence(evidenceIndex);
		},
		async removeEvidence(evidenceIndex: number) {
			const evidence = this.presentTemplateTask?.evidences?.[evidenceIndex];
			const url = evidence?.url;
			const isUrlEvidence = evidence?.evidenceType === 'url';
			const statusCode = this.presentTemplateTask?.statusCode;
			if (statusCode == 10403 || statusCode == 10420 || statusCode == 10418) {
				return;
			}
			try {
				let urlStillUsed = false;
				if (!isUrlEvidence && url) {
					const tasksResponse = await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`);
					const tasks = Array.isArray(tasksResponse?.data) ? tasksResponse.data : [];
					const currentId = String(this.currentTaskId || '');
					urlStillUsed = tasks.some((task: any) => String(task?._id || '') !== currentId && Array.isArray(task?.evidences) && task.evidences.some((doc: any) => doc?.url === url));
				}
				if (!isUrlEvidence && url && !urlStillUsed) {
					const fileResponse = await this.$http.post(`${process.env.VUE_APP_FILE_API}/bucket/file/delete`, { url });
					if (!(fileResponse.status == 200 && fileResponse.data?.deleted === true)) {
						return;
					}
				}
				await this.$http.post(
					`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.currentTaskId}/evidence/remove`,
					{ evidenceIndex, createdBy: this.userInfo._id }
				);
				await this.getPresentTemplateTask();
				await this.getParentTaskHistoryObject();
			} catch (err) {
				toast.error(`Failed to remove evidence`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
			async getAllBusinessProcesses() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20006}`).then((result: any) => {
				this.allProcess = result.data
            });
			for(let i=0;i<this.allProcess.length;i++){
				this.optionsActivityArray.push({ label: this.allProcess[i].businessProcessName, value: this.allProcess[i]._id });
			}
		},
		async getAllSystems(){
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/getall/${20005}`).then((result: any) => {
				this.allSystems = result.data;
				// this.orgUsersList = res.data
				for (var i = 0; i < this.allSystems.length; i++) {					
					this.optionSystemArray.push({ label: this.allSystems[i].systemName, value: this.allSystems[i]._id });
				}
			});
		},
		onCancelIcon(){
			this.importpopUp = false
			this.inputFileName = ''
			this.fileName = ''
			this.evidenceDate=''
			this.fileToUpload=null
			this.evidenceUrl = ''
			this.evidenceAttachMode = 'file'
			this.selectedExistingEvidences = []
			this.v$.$reset();
		},
		getStatusLabel(num:any){
			// let result = this.parentTaskStatus.find((obj:any)=>{return obj.id == num})
			// return result.value
			if(this.statuses.parentTaskStatus!=undefined && num!=undefined){
				let result: any = this.statuses.parentTaskStatus.find((data: any)=>{
				return data.id == num
				})			
				if(result != undefined){
					return result.label
				} else{
					return 'N/A'
				}
			}
		},
		// updateAuditResult() {
		// 	const category = this.findingsObject.findingCategory;
		// 	if (category === 1 || category === 2) {
		// 		this.findingsObject.auditResult = 'Fail';
		// 	} else if (category === 3 || category === 4) {
		// 		this.findingsObject.auditResult = 'Pass';
		// 	} else {
		// 		this.findingsObject.auditResult = '';
		// 	}
		// },
		scrollTabIntoView(tabId : any) {
			this.$nextTick(() => {
				const tabElement = this.$el.querySelector(`.tab:nth-child(${tabId})`);
				if (tabElement) {
				tabElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
				}
			});
		},
		getTeamName(team: any) {
            let teamObj = this.users.find((obj: any) => {
                return obj._id == team;
            });
            if (teamObj == undefined) {
                return '';
            } else {
                return teamObj.teamName;
            }
        },
		filterOpen() {
			this.showFilters = !this.showFilters;
			// if (this.showFilters == true) {
			// 	this.dummyList = this.savedAuditSets;
			// } else {
			// 	this.savedAuditSets = this.dummyList;
			// }
			emitter.emit('visible', this.showFilters);
		},
		getBorder(){
            return `numberBorder numberNavy`
        },
		openApprovalpopup(){
			this.showApprovalPopup = true
		},
		onCancelbtnAtApproval(){
			this.v$.$reset();
			this.taskObj.approver = ''
			this.taskObj.approvalComments = ''
		},
		onCrossbtn(){
			this.v$.$reset();
			this.taskObj.approver = ''
			this.taskObj.approvalComments = ''
			this.showApprovalPopup =  false
		},
		checkOwner(){
			let approver: any 
			if(this.presentTemplateTask.approvals){
				let approvals: any = this.presentTemplateTask.approvals
				approvals.forEach((obj:any) => {
					approver = obj.approver
				});
				if(this.userInfo.organisationType==10701 && this.userInfo.role_id!=10217){
					return true;
				}
				if(approver == this.userInfo._id || this.userInfo.roleId!=10217){
					return true
				} else{
					return false
				}
			}
		},
		async getAllActiveControls(){
		await this.$http
			.get(`${process.env.VUE_APP_CONTROLS_API}/api/org/controls/active`)
			.then((result: { data: any }) => {
				this.allActiveControls = result.data;
			})
			.catch((error: any) => {
				toast.error(` ${error}`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			});
        },
		clickOnSaveForApproval(obj: any){
			// (TYPE = 3) for sending approvals
			// {approver:'userId',createdBy:'',createdAt:''}
			let payload: any = {
				approver :obj.approver.value,
			}
			this.v$.$touch();
			if(!this.v$.taskObj.$invalid){
				this.clickOnButton = true;
				this.updateTemplateTask(3,payload)
				this.taskObjDummy = {approver:'',approvalComments:''}
				// this.checkOwner();
				this.taskObj.approver = ''
				this.taskObj.approvalComments = ''
				this.showApprovalPopup = false
				this.v$.$reset();
			}
			
			
		},
		async approveOrRejectTheParentApproval(statusCode: any){
			this.clickOnButton = true;
			let taskId: any = this.currentTaskId
			const payload: any={
				statusCode: statusCode,
				updatedBy: this.userInfo._id
			}
			// /api/org/task/:taskId/update/approval

			// POST

			// => payload for approving approval

			// {statusCode: 10403 , updatedBy:'',updatedAt:''}
			await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${taskId}/update/approval`,payload).then((res: any) => {
                
            });
			if(statusCode == 10403){
				
                toast.success(`Approval Approved`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				await this.getParentTaskHistoryObject()
            }else if(statusCode == 10401){
				
                toast.error(`Approval Rejected`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
				});
				await this.getParentTaskHistoryObject() 
            }
			this.clickOnButton = false;
			await this.getPresentTemplateTask();
			// this.workLogObject.taskHistory.sort().reverse();
		},
		async getAllActiveUsers() {
			await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
				this.orgUsersList = res.data;
				
				for (var i = 0; i < this.orgUsersList.length; i++) {
					// if(this.orgUsersList[i].isActive == true){
						this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					// }
					if(this.userInfo._id != this.orgUsersList[i]._id){
						this.approvingMembers.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					}
				}
			});
		},
		setBreadcrumbs() {
			const taskLabel = this.presentTemplateTask?.taskId || 'N/A';
			this.routesArray = [
				{ name: 'Task', routeName: 'tasks' },
				{ name: taskLabel, routeName: 'templateTaskEdit' },
			];
		},
		emitHeaderInfo() {
			if (!this.modalMode) {
				return;
			}
			this.$emit('header-info', {
				id: this.presentTemplateTask?.taskId || '',
				title: this.presentTemplateTask?.mainTaskName || this.presentTemplateTask?.TaskName || '',
			});
		},
		// /api/org/task/:taskId/get
		async getPresentTemplateTask() {
			let taskId : any = this.currentTaskId
			try {
				const res: any = await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${taskId}/get`);
				this.presentTemplateTask = res.data;
				this.pageStatus = res.status;
				this.TaskDetailsDropDown.taskStatus = this.presentTemplateTask.statusCode;
				if(this.presentTemplateTask.assignee != undefined){
					let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentTemplateTask.assignee});
					this.presentTemplateTask.assignee = userObj;
				}else{
					let userObj:any = this.optionsUserArray.find((obj:any)=>{return obj.value == this.presentTemplateTask.auditor});
					this.presentTemplateTask.assignee = userObj;
				}
				this.dummyPresentSubTask = {...this.presentTemplateTask};
				if(this.presentTemplateTask !=undefined && this.presentTemplateTask.completedAt!='' && typeof this.presentTemplateTask.completedAt=='string'){
					this.presentTemplateTask.completedAt = moment(this.presentTemplateTask.completedAt).format('YYYY-MM-DD')
				}
				if(this.presentTemplateTask.startDate!=undefined && this.presentTemplateTask.startDate!=''){
					this.presentTemplateTask.startDate=moment(this.presentTemplateTask.startDate).format('YYYY-MM-DD')
				}
				if(this.presentTemplateTask.dueDate!=undefined && this.presentTemplateTask.dueDate!=''){
					this.presentTemplateTask.dueDate=moment(this.presentTemplateTask.dueDate).format('YYYY-MM-DD')
				}
				this.emitHeaderInfo();
			} catch (error: any) {
				toast.error(`Failed to load task`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				throw error;
			}
        },
		async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityName, value: result[i]._id });
            }
        },
		async getAllTeams() {
            this.teamObject = []
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].displayName, value: this.users[i]._id });
            }
        },
		getPersonName(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {
              
				return user._id == person;
			});
			if (personObj == undefined  && person==undefined) {
				return '';
			}else if(person!=undefined && personObj==undefined){												
				if(this.userInfo._id==person){										
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
		getPerson(person: any) {
			this.personObj = this.orgUsersList.find((user: any) => {
              
				return user._id == person;
			});
			if (this.personObj == undefined) {
				return '';
			} else {
				return this.personObj.name;
			}
		},
		sortWorkLog() {
			this.newHistory = !this.newHistory;
			this.workLogObject.taskHistory.sort().reverse();
		},
		sortComments() {
			this.oldComments = !this.oldComments;
			if(this.presentTemplateTask.comments != undefined){
				this.presentTemplateTask.comments.sort().reverse();
			}
		},
		formatTime(time: any) {
			let now = moment(time);
			return now.format('DD-MM-YYYY, HH:mm:ss');
		},
		extractInitials(name: any) {
			if(name!=undefined){
			const names = name.split(" ");
			return names
			.map((name: any) => name[0])
			.join("")
			.toUpperCase();
			}
			else{
				return '';
			}
		},
		changeBackground() {
			if (this.TaskDetailsDropDown.taskStatus == 10411) {
				return 'bg-disabledgrey textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10415 || this.TaskDetailsDropDown.taskStatus == 10421) {
				return 'bg-yellow textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10402) {
				return 'bg-electricGreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10403) {
				return 'bg-lightgreen textColorWhite';
			} else if (this.TaskDetailsDropDown.taskStatus == 10401) {
				return 'bg-primary textColorWhite';
			} else {
				return '';
			}
		},
		checkAuditor(id:any){
			if(id == this.userInfo._id){
				return true
			} else if(id == undefined || id == null){
				return false
			} else {
				return false
			}
		},
		async updateTaskStatus(status: any) {
			let payload: any = { statusCode: status };
			await this.updateTemplateTask(5,payload)
		},
		async updateAssignedMember(obj: any) {
			let payload: any = { assignee: obj.value };
			await this.updateTemplateTask(6,payload)
		},
		handleInput() {
			this.btnDisabled = this.comment.length === 0;
		},
		async addComment() {
			if (this.comment.trim() !== '') {
				const newComment: any = {
					comment: this.comment
				};
				await this.updateTemplateTask(4, newComment);
				// this.comments.push(newComment);
				// if(this.presentTemplateTask.comments != undefined){
				// 	this.presentTemplateTask.comments.sort().reverse();
				// }
				this.comment = '';
				this.btnDisabled = true;
			}
		},
		clearComment() {
			this.comment = '';
			this.btnDisabled = true;
		},
		async toggleTabs(obj: any) {
			this.scrollTabIntoView(obj.id);
			this.selectedTabIndex = obj.id;
			this.selectedTabObj = obj;
			await this.getPresentTemplateTask()
			if(obj.id==7){
				await this.getParentTaskHistoryObject()

			}
		},
		
		onCancelButtonAddPopUp() {
			this.v$.$reset();
			this.showSubTaskPopUp = false;
		},
		onCancelbtn(){
			this.v$.$reset();
			this.subTaskDetailsObj = {...this.subTaskDetailsObjDummy}
			// this.showSubTaskPopUp = false;
		},
		openFilePopup(mode: string = 'file') {
			this.evidenceAttachMode = mode === 'url' ? 'url' : 'file'
			this.evidenceUrl = ''
			this.fileName = ''
			this.fileToUpload = null
			this.pdfValidation = false
			this.inputFileName = ''
			this.evidenceDate = ''
			this.v$.$reset()
			this.importpopUp = true
		},
		async loadExistingFileOptions() {
			try {
				const res = await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`);
				this.linkEvidenceTasks = Array.isArray(res?.data) ? res.data : [];
			} catch (error) {
				this.linkEvidenceTasks = [];
				toast.error(`Failed to load tasks`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			}
		},
		resetExistingEvidenceTable() {
			this.existingEvidenceSortKey = '';
			this.existingEvidenceSortDir = 'asc';
			this.showExistingEvidenceFilters = false;
			this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
		},
		toggleExistingEvidenceFilters() {
			this.showExistingEvidenceFilters = !this.showExistingEvidenceFilters;
			if (!this.showExistingEvidenceFilters) {
				this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
			}
		},
		sortExistingEvidence(key: string) {
			if (this.existingEvidenceSortKey === key) {
				this.existingEvidenceSortDir = this.existingEvidenceSortDir === 'asc' ? 'desc' : 'asc';
			} else {
				this.existingEvidenceSortKey = key;
				this.existingEvidenceSortDir = 'asc';
			}
		},
		openLinkEvidencePopup() {
			this.selectedLinkTask = null
			this.selectedExistingFiles = []
			this.selectedExistingLinks = []
			this.selectedExistingEvidences = []
			this.resetExistingEvidenceTable();
			this.linkEvidencePopup = true
			this.loadExistingFileOptions();
		},
		closeLinkEvidencePopup() {
			this.linkEvidencePopup = false
			this.selectedLinkTask = null
			this.selectedExistingFiles = []
			this.selectedExistingLinks = []
			this.selectedExistingEvidences = []
			this.resetExistingEvidenceTable();
		},
		onLinkTaskChange() {
			this.selectedExistingFiles = []
			this.selectedExistingLinks = []
			this.selectedExistingEvidences = []
		},
		syncSelectedExistingEvidences() {
			this.selectedExistingEvidences = [...this.selectedExistingFiles, ...this.selectedExistingLinks];
		},
		isExistingEvidenceSelected(row: any) {
			return (this.selectedExistingEvidences || []).some((item: any) => item.optionKey === row.optionKey);
		},
		toggleExistingEvidence(row: any) {
			const selected = [...(this.selectedExistingEvidences || [])];
			const index = selected.findIndex((item: any) => item.optionKey === row.optionKey);
			if (index >= 0) {
				selected.splice(index, 1);
			} else {
				selected.push(row);
			}
			this.selectedExistingEvidences = selected;
		},
		async saveLinkedEvidence() {
			const docs = this.selectedExistingEvidences || [];
			const evidences = docs.filter((doc: any) => doc?.url).map((doc: any) => {
				const filename = doc.filename || doc.name;
				const item: any = {
					url: doc.url,
					filename,
					evidenceDate: doc.evidenceDate,
					evidenceType: doc.evidenceType || 'file'
				};
				if (doc.fileType !== undefined && doc.fileType !== null) {
					item.fileType = doc.fileType;
				}
				if (doc.sourceTaskId != null && String(doc.sourceTaskId) !== '') {
					item.linkedEvidenceTaskId = String(doc.sourceTaskId);
				}
				return item;
			});
			if (!evidences.length) return;
			this.linkEvidencePopup = false;
			try {
				await this.updateTemplateTask(2, { evidences });
				this.resetEvidenceForm();
			} catch (err) {
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				this.resetEvidenceForm();
			}
		},
		onEvidenceSave() {
			this.handleFileChange();
		},
		updateFileName(event: any) {
			// const selectedFile = event.target.files[0];
			// this.newDocumentObj.file = selectedFile;
			let file = this.$refs.fileInput.files[0];

			if (file && !file.type.match('application/pdf') && !file.name.endsWith('.doc') && !file.name.endsWith('.docx')) {
				alert('Please select a PDF, DOC, or DOCX file.');
				return;
			} else {
				this.fileChanged = true;
				this.fileToUpload.file = file;
			}
		},
		resetEvidenceForm() {
			this.inputFileName = ''
			this.fileName = ''
			this.evidenceDate = ''
			this.fileToUpload = null
			this.evidenceUrl = ''
			this.evidenceAttachMode = 'file'
			this.selectedExistingFiles = []
			this.selectedExistingLinks = []
			this.selectedExistingEvidences = []
			this.selectedLinkTask = null
			this.v$.$reset();
		},
		async handleUrlEvidenceSave() {
			this.v$.inputFileName.$touch()
			this.v$.evidenceUrl.$touch()
			this.v$.evidenceDate.$touch()
			if (this.v$.inputFileName.$invalid || this.v$.evidenceUrl.$invalid || this.v$.evidenceDate.$invalid) {
				return;
			}
			this.importpopUp = false
			try {
				const payload: any = {
					url: this.evidenceUrl,
					filename: this.inputFileName,
					evidenceDate: new Date(this.evidenceDate).toISOString(),
					evidenceType: 'url'
				};
				await this.updateTemplateTask(2, payload);
				this.resetEvidenceForm();
			} catch (err) {
				console.error(err);
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				this.resetEvidenceForm();
			} finally {
				this.clickOnButton = false;
			}
		},
		async handleFileChange(event: any) {
			if (this.evidenceAttachMode === 'url') {
				await this.handleUrlEvidenceSave();
				return;
			}

			let data = this.fileToUpload;
			// this.fileToUpload = data
			this.v$.inputFileName.$touch()
			this.v$.fileToUpload.$touch()
			this.v$.evidenceDate.$touch()
			if(((!this.v$.fileToUpload.$invalid) && (!this.v$.inputFileName.$invalid)  && (!this.v$.evidenceDate.$invalid))){
			this.importpopUp = !this.importpopUp
			let fileExtension = data.name.split('.').pop();
			if (fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' || fileExtension == 'xlsx' || fileExtension == 'jpeg'|| fileExtension == 'png'|| fileExtension == 'jpg' || fileExtension == 'mp4'|| fileExtension == 'doc' || fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' || fileExtension=='zip' || fileExtension == 'ods') {
				const fileDataFormat = await this.getConvertDataForFile(data);
				let uuid = uuidv4();
				let payload = { fileData: fileDataFormat,fileType: 1, name: `${uuid}.${fileExtension}` };
					let folderName = `${process.env.VUE_APP_PLANNER_FOLDER_NAME}`;
				try {
					await this.$http
						.post(`${process.env.VUE_APP_FILE_API}/bucket/${folderName}/file/upload`, payload)
						// .post(`http://localhost:4030/services/filemanagement/bucket/${folderName}/file/upload`, payload)
						// bucket/:folderName/file/upload
						.then(async (response: any) => {
							if (response.status == 200) {
								let payload: any = {
									// name: `${uuid}.${fileExtension}`,
									url: response.data,
									filename:this.inputFileName,
									evidenceDate: new Date(this.evidenceDate).toISOString(),
									fileType: 1,
									evidenceType: 'file'
								};
								await this.updateTemplateTask(2, payload);
								this.resetEvidenceForm();
							} else {
								// console.log('response status', response.status);
							}
						});
				} catch (err) {
					console.error(err);
				}
			} else {
				toast.error(`Upload only pdf`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
				this.v$.$reset();
			}
			this.fileName = '';
            this.inputFileName = '';
			this.fileToUpload=null
			}
		},
		async getConvertDataForFile(data: any) {
			return new Promise((resolve) => {
				const reader: any = new FileReader();
				reader.onload = function () {
					resolve(reader.result);
					// resolve(reader.result.replace('data:', '').replace(/^.+,/, ''));
				};
				reader.readAsDataURL(data);
			});
		},
		async getAllSubTasksForTemplate() {
			this.tableRow = []
			let mainTaskId:any = this.presentTemplateTask._id
		
			await this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${mainTaskId}/subTasks/get`).then((res: any) => {
                this.allSubTasks = res.data;
				let title:any
                let subtaskTeam: any
                this.allSubTasks.forEach((subTask:any) => {
 
                    let controlObj:any = this.allActiveControls.find((obj: any)=>{return obj._id == subTask.control});
                    let teamName:any = this.users.find((team: any)=>{return team._id == subTask?.departments});
 
                    let assignee:any = this.optionsUserArray.find((assigneeName: any)=>{return assigneeName.value == subTask.assignee})
                   
                    if(subTask.title){
                        title=subTask.title
                    }else{
                        title=subTask?.TaskName||'N/A'
                    }
 
                    let subTaskObj:any = {
                        _id: subTask._id,
                        ccid: subTask?.clientUniqueId != undefined ? subTask.clientUniqueId : 'N/A',
                        subTasktitle:title,
                        team: teamName != undefined ? teamName.displayName : 'N/A',
                        startDate:subTask.startDate,
                        dueDate:subTask.dueDate,
                        SubTaskStatus:subTask.statusCode,
                        description: subTask.description ? subTask.description: controlObj.controlGuidance,
                        assignee: assignee,
                        notes:subTask.notes,
                        mainTaskId:subTask.mainTaskId
                    }
                    this.tableRow.push(subTaskObj)
                });
            });
            
        },
		async updateTemplateTask(type: any, payload: any,dateType:any) {
			if(this.presentTemplateTask!=undefined && this.presentTemplateTask.statusCode!=undefined && payload.status!=undefined && this.presentTemplateTask.statusCode==payload.status){
				return;
			}
			payload.createdBy = this.userInfo._id;
			payload.updatedAt=new Date();
			payload.updatedBy = this.userInfo._id;

			if(type == 2){
				if (Array.isArray(payload.evidences)) {
					const taskIdValue = this.presentTemplateTask?.taskId;
					payload.evidences.forEach((item: any) => {
						item.createdBy = payload.createdBy;
						item.updatedAt = payload.updatedAt;
						item.updatedBy = payload.updatedBy;
						item.taskId = taskIdValue;
						item.additionalInfo = { evidence: item.filename, evidenceDate: item.evidenceDate };
						item.fileType = item.fileType;
					});
				} else {
				payload.taskId = this.presentTemplateTask?.taskId
				payload.additionalInfo = {evidence:'',evidenceDate:''};
				payload.additionalInfo.evidence = payload.filename;
				payload.additionalInfo.evidenceDate=payload.evidenceDate;
				payload.fileType=payload.fileType
				}
			} else if(type == 3){
				payload.additionalInfo = {approver:''};
				payload.additionalInfo.approver = payload.approver;
			} else if(type == 4){
				payload.additionalInfo = {comment:''};
				payload.additionalInfo.comment = payload.comment;
			} else if(type == 5){
				payload.additionalInfo = {previousStatus:'',updatedStatus:''};
				payload.additionalInfo.previousStatus = this.presentTemplateTask.statusCode;
				payload.additionalInfo.updatedStatus = payload.statusCode;
			} else if(type == 6){
				payload.additionalInfo = {assignee:''};
				payload.additionalInfo.assignee = payload.assignee;
			} else if(type == 7){
				payload.additionalInfo = {createdBy:''};//the person who have started the task
				payload.additionalInfo.createdBy = payload.createdBy;
				// payload.additionalInfo.updatedAt= payload.updatedAt;
			}
			else if(type ==8) {
				payload.additionalInfo = [];
                let now = new Date();
           
                if (dateType == 20604) {
					console.log()
                    let selectedStartDate = new Date(this.dummyTemplateTask.startDate);
					selectedStartDate.setHours(
						now.getHours(),
						now.getMinutes(),
						now.getSeconds(),
						now.getMilliseconds()
					);
                    payload.additionalInfo.push({
                        previousStartDate: selectedStartDate,
                        updatedStartDate: payload.startDate,
                        dateId: 20604
                    });
                }
                if (dateType == 20605) {
                    let selectedEndDate = new Date(this.dummyTemplateTask.dueDate);
                    selectedEndDate.setHours(
                        now.getHours(),
                        now.getMinutes(),
                        now.getSeconds(),
                        now.getMilliseconds()
                    );
                    payload.additionalInfo.push({
                        previousEndDate: selectedEndDate,
                        updatedEndDate: payload.endDate,
                        dateId: 20605
                    });
                }
				if(payload.completedAt && payload.completedAt!='') {
				let now = new Date();
				payload.completedAt = new Date(payload.completedAt);
				payload.completedAt.setHours(
					now.getHours(),
					now.getMinutes(),
					now.getSeconds(),
					now.getMilliseconds()
				);
				if(this.dummyPresentSubTask.completedAt && this.dummyPresentSubTask.completedAt!=''){
					this.dummyPresentSubTask.completedAt = new Date(this.dummyPresentSubTask.completedAt);
				this.dummyPresentSubTask.completedAt.setHours(
					now.getHours(),
					now.getMinutes(),
					now.getSeconds(),
					now.getMilliseconds()
				);
				}
				
				payload.updatedAt = new Date().toISOString();				
				// this.dummyPresentSubTask.completedAt =  new Date(this.dummyPresentSubTask.completedAt)
				payload.updatedBy = this.userInfo._id;
				delete payload.createdBy;
				let additionalInfoArr:any=[];
				let additionalInfo:any={};
				additionalInfo.previousCompletionDate = this.dummyPresentSubTask.completedAt,
				additionalInfo.updatedCompletionDate = payload.completedAt
				additionalInfo.dateId = 20606
				additionalInfoArr.push(additionalInfo);
				payload.additionalInfo = additionalInfoArr
			}
			}
			// /api/org/task/${this.currentTaskId}/type/${type}/update
			try {
				// if (this.presentTemplateTask!=undefined &&this.presentTemplateTask!=''&&this.presentTemplateTask.startDate!=undefined&&this.presentTemplateTask.startDate&&
                // this.presentTemplateTask.dueDate==this.presentTemplateTask.startDate) {
				// 	toast.info(`Start date and Due date cannot be the same`, {
				// 			timeout: 1000,
				// 			closeOnClick: true,
				// 			closeButton: 'button',
				// 			icon: true
				// 		});
				// }
				// else{
				await this.$http.post(`${process.env.VUE_APP_PLANNER_API}/api/org/task/${this.currentTaskId}/type/${type}/update`, payload).then(async (result: any) => {
					toast.info(`Updated`, {
						timeout: 1000,
						closeOnClick: true,
						closeButton: 'button',
						icon: true
					});
				});
				
			// }
		}catch {
				toast.error(`Error`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			} finally {
                this.clickOnButton = false;
            }
			await this.getAllSubTasksForTemplate();
			await this.getPresentTemplateTask();
			await this.getParentTaskHistoryObject();
			// this.workLogObject.taskHistory.sort().reverse();
		},
		colorTemplateText(status: any) {
			if (status == 10411) {
				return ['font-semibold text-xs text-disabledgrey'];
			} else if (status == 10415 || status == 10421) {
				return ['font-semibold text-xs text-yellow'];
			} else if (status == 10403) {
				return ['font-semibold text-xs text-lightgreen'];
			} else if(status == 10402){
				return ['font-semibold text-xs mx-2 text-electricGreen']
			} else if(status == 10401){
				return ['font-semibold text-xs mx-2 text-darkred']
			} else{
				return 'N/A'
			}
		},
		colorTemplateBg(status: any) {
			if (status == 10411) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10415 || status == 10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10402) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10401) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			} 
		},
		getSubtaskObject(subTask: any){
			let title:any
			let subtaskTeam: any
			let controltitle: any = this.allActiveControls.find((obj: any)=>{return obj._id == subTask.control})
			let teamName: any = this.users.find((team: any)=>{return team.teamOwner == subTask.assignee})
			let assignee: any = this.optionsUserArray.find((assigneeName: any)=>{return assigneeName.value == subTask.assignee})
			if(subTask.team == null || subTask.team == undefined){
				subtaskTeam = this.teamObject.find((teamName: any)=>{return teamName.value == controltitle.departments})
			} else {
				subtaskTeam = this.teamObject.find((teamName: any)=>{return teamName.value == subTask.team})
			}
			
			if(subTask.title){
				title=subTask.title
			}else{
				title=controltitle.controlTitle	
			}
			let subTaskObj:any = {
				_id:subTask._id,
				subTasktitle:title,
				team:subtaskTeam != undefined?(subtaskTeam!= undefined? subtaskTeam:''):'',
				startDate:subTask.startDate,
				dueDate:subTask.dueDate,
				description: subTask.description?subTask.description:controltitle.controlGuidance,
				assignee: assignee,
				notes:subTask.notes != undefined ? subTask.notes : '',
			}
			
			this.subTaskDetailsObj = {...subTaskObj}
		},
		async getTaskStatuses(){
			let appId='10007';
			let entityId='10117';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {				
                this.statuses = result.data
				// this.taskStatuses = result.data.filter((status:any)=>status.id==10401 || status.id==10402);
				// this.subTaskStatuses = result.data.filter((status:any)=>status.id==10402 || status.id==10403);				
			});
		},
		async onRelatedTaskRowClick(dataObj:any){
			let selectedSubTaskId:any = dataObj._id;
			let getSelectedObj: any = this.allSubTasks.find((obj: any) => {
				return obj._id === selectedSubTaskId;
			});
			this.getSubtaskObject(getSelectedObj);

			if(dataObj.SubTaskStatus == 10411){
				this.showSubTaskPopUp = true
			} else if (this.modalMode) {
				this.$emit('open-subtask', { subtaskId: dataObj._id, taskId: this.presentTemplateTask._id || this.presentTemplateTask.id || this.currentTaskId });
			} else {
				this.$router.push({ name: 'subTaskEditfromtask', params: { taskId: this.presentTemplateTask.id,subtaskId:dataObj._id  },query: { tasks: true } });
			}

			this.subTaskDetailsObjDummy = {...this.subTaskDetailsObj}
		}
	},
	async mounted(){
		emitter.off('addedComments');
		emitter.on('addedComments',(data: any)=>{
			this.comment = data.comments
			this.addComment()
		})
		emitter.off('activiteToolTip');
			emitter.on('activiteToolTip', (data: any) => {
				this.toolTipActive = true;
				this.toolTipText = data.tipText
			});
			emitter.off('deActiviteToolTip');
			emitter.on('deActiviteToolTip', (data: any) => {
				this.toolTipActive = false;
				this.toolTipText = ''
			});
		window.addEventListener('resize', this.clampLinkWidthsToContainer);
	},
	async created(){
		this.isComponentActive = true;
		try {
			await this.getAllActiveUsers();
			await this.getPresentTemplateTask();
			this.setBreadcrumbs();

			await Promise.allSettled([
				this.getTaskStatuses(),
				this.getAllSystems(),
				this.getAllBusinessProcesses(),
				this.getAllTeams(),
				this.getAllActiveControls(),
			]);

			if (this.presentTemplateTask) {
				this.dummyTemplateTask = { ...this.presentTemplateTask };
			}

			await Promise.allSettled([
				this.getAllSubTasksForTemplate(),
				this.getParentTaskHistoryObject(),
			]);

			const savedTabKey = sessionStorage.getItem('selectedTab');
			if (savedTabKey) {
				const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
				if (savedTab) {
					await this.toggleTabs(savedTab);
				} else {
					this.selectedTabObj = { displayName: 'Description', id: 1 };
					this.selectedTabIndex = 1;
				}
			} else {
				this.selectedTabObj = { displayName: 'Description', id: 1 };
				this.selectedTabIndex = 1;
			}

			this.setBreadcrumbs();

			if (!this.isComponentActive) {
				return;
			}
			emitter.off('clickedOnRowData')
			emitter.on('clickedOnRowData', this.onRelatedTaskRowClick)
			if(this.presentTemplateTask?.comments != undefined){
				this.presentTemplateTask.comments.sort().reverse();
			}
			this.titleLength = this.presentTemplateTask?.mainTaskName ? this.presentTemplateTask.mainTaskName.length : 0;
			this.titleLengthForTaskName = this.presentTemplateTask?.TaskName ? this.presentTemplateTask.TaskName.length : 0;
		} catch {
			this.setBreadcrumbs();
		}
	},
	beforeUnmount() {
         this.stopLinkColumnResize();
         window.removeEventListener('resize', this.clampLinkWidthsToContainer);
         sessionStorage.removeItem('selectedTab')
		 this.isComponentActive = false
		 emitter.off('clickedOnRowData', this.onRelatedTaskRowClick)
    },
	
});
</script>
